import Button from "components/common/Button";
import CustomToast from "components/common/CustomToast";
import Checkbox from "components/common/InputField/Checkbox";
import SelectInput from "components/common/InputField/SelectInput";
import TextareaInput from "components/common/InputField/TextareaInput";
import TextInput from "components/common/InputField/TextInput";
import ToggleInput from "components/common/InputField/ToggleInput";
import ModalContainer from "components/common/ModalContainer";
import SynthTooltip from "components/common/SynthTooltip";
import { isFileSizeLessThanOrEqualTo } from "helpers/compareFileSizeInMb";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import Tabs from "./tabs";
import Preview from "./Preview";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "hooks/storeHooks";
import { authActions, vendorActions, workforceActions } from "redux/Ldb/actions";
import { getAgentName } from "helpers/getAgentName";
import { debounce } from "lodash";
import useGetUserProfile from "hooks/useGetUserProfile";
import { displayFileIcon, getFromStorage, removeFromStorage, saveToStorage } from "helpers";
import { camelCaseToRegularCase } from "helpers/camelCaseToRegularCase";
import EmptyStateComp from "components/common/EmptyStateComp";
import { displayProductChannelIcon } from "helpers/displayProductChannelIcon";
import { AccountPermissions } from "types/permissions";
import Loader from "components/common/Loader";
import { useNavigationHandler } from "hooks/useNavigationHandler";
import { emailRegex } from "helpers/emailRegex";
import { firebaseService } from "services/firebaseService";
import { getFileTypeFromUrl } from "helpers/getFileTypeFromUrl";
import MarketingCampaign from "components/views/Synth2.0/AiAgent/Setup/MarketingCampaign";
import { aiAvatarArr, AiNameSuggestions } from "variables/CreateAiTeammateDate";
import AddTeamMemberModal from "components/views/Synth2.0/TeamMember/AddTeamMemberModal";
import AgentSideDrawer from "components/common/AgentSideDrawer";
import EDIAssistant from "components/views/Synth2.0/AiAgent/Setup/EDIAssistant";
import InventoryManagement from "components/views/Synth2.0/AiAgent/InventoryManagement";

const Setup = ({
    setActiveTab,
    activeTab,
}: {
    setActiveTab: (tab: number) => void;
    activeTab: number;
}) => {
    const dispatch = useAppDispatch();
    const { agentId } = useParams();
    const [param] = useSearchParams();
    const taskId = param.get("taskId");
    const navigate = useNavigate();
    const [currentStep, setCurrentStep] = useState<string>("");
    const [aiAgentName, setAiAgentName] = useState<string>("");
    const [sourceActionTrigger, setSourceActionTrigger] = useState<string>("");
    const [openPreview, setOpenPreview] = useState<boolean>(false);
    const [agentDetails, setAgentDetails] = useState<Record<string, any>>({});
    const [agentSteps, setAgentSteps] = useState<Record<string, any>[]>([]);
    const [currentStepIndex, setCurrentStepIndex] = useState<number>(0);
    const [debouncedSearchTeamMember, setDebouncedSearchTeamMember] = useState<string>("");
    const [teamMembers, setTeamMembers] = useState<Record<string, any>[]>([]);
    const [addNewMember, setAddNewMember] = useState<boolean>(false);
    const [emailClientModal, setEmailClientModal] = useState<boolean>(false);
    const [emailClientSocialId, setEmailClientSocialId] = useState<string>("");
    const [selectedAction, setSelectedAction] = useState<string>("");
    const [agentIsActive, setAgentIsActive] = useState(false);
    const [successModal, setSuccessModal] = useState(false);
    const [additionalEmails, setAdditionalEmails] = useState<string>("");
    const [valueArray, setValueArray] = useState<string[]>([]);
    const [uploadingDoc, setUploadingDoc] = useState<boolean>(false);
    const [aiTeammateId, setAiTeammateId] = useState<string>("");
    const [avatar, setAvatar] = useState<string>("");
    const avatarModalRef = useRef<HTMLDivElement>(null);
    const modalRef = useRef<HTMLDivElement>(null);
    const [profile] = useGetUserProfile();
    const userProfile = getFromStorage("ally-user");
    const [hasSavedData, setHasSavedData] = useState<boolean>(false);
    const [openAvatarModal, setOpenAvatarModal] = useState<boolean>(false);
    const [uploadingAvatar, setUploadingAvatar] = useState<boolean>(false);
    const [lastActiveIndex, setLastActiveIndex] = useState<number>(-1);
    const [addTeamMemberModal, setAddTeamMemberModal] = useState<boolean>(false);
    const [actionChanged, setActionChanged] = useState<boolean>(false);
    const [createOrderAction, setCreateOrderAction] = useState<string>("");
    const [createOrderActionStep, setCreateOrderActionStep] = useState<
        {
            label: string;
            value: string;
        }[]
    >([]);
    const [selectedMarketingConnection, setSelectedMarketingConnection] = useState<
        {
            [key: string]: any;
        }[]
    >([]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                avatarModalRef.current &&
                !avatarModalRef.current.contains(event.target as Node) &&
                openAvatarModal
            ) {
                setOpenAvatarModal(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [avatarModalRef, openAvatarModal]);

    //    useEffect(() => {
    //        if (!currentStep) return; // don't listen when closed

    //        const handleOutside = (e: MouseEvent) => {
    //            if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
    //                setCurrentStep("");
    //            }
    //        };

    //        document.addEventListener("mousedown", handleOutside);
    //        return () => document.removeEventListener("mousedown", handleOutside);
    //    }, [currentStep]);

    const { fetchingTeamMember, fetchedTeamMemberSuccess, addingTeamMember, addTeamMemberSuccess } =
        useAppSelector((state) => state.auth);

    const {
        fetchSingleAgentSuccess,
        fetchingSingleAgent,
        createAiTeammateSuccess,
        creatingAiTeammate,
        updateAiTeammateSuccess,
        updatingAiTeammate,
    } = useAppSelector((state) => state?.workforce);
    const { fetchedAllChannelsSuccess, fetchingAllChannels } = useAppSelector(
        (state) => state.vendor
    );
    useEffect(() => {
        dispatch(vendorActions.getAllChannels());
    }, [dispatch]);

    useEffect(() => {
        dispatch(
            authActions.getTeamMembers(
                40,
                debouncedSearchTeamMember,
                null,
                profile?.isMultiBrandAccount || profile?.accountType === "brand"
                    ? userProfile?.mainToken || userProfile?.token
                    : profile?.token
            )
        );
    }, [
        dispatch,
        debouncedSearchTeamMember,
        addTeamMemberSuccess,
        profile?.token,
        profile?.isMultiBrandAccount,
        profile?.accountType,
        userProfile?.mainToken,
        userProfile?.token,
    ]);

    useEffect(() => {
        if (Boolean(fetchedTeamMemberSuccess)) {
            setTeamMembers(fetchedTeamMemberSuccess.teamMembers);
        }
    }, [fetchedTeamMemberSuccess]);

    useEffect(() => {
        if (Boolean(addTeamMemberSuccess)) {
            setAddNewMember(false);
        }
    }, [addTeamMemberSuccess]);

    const savedData = getFromStorage("createAiAgentForm");

    useEffect(() => {
        if (fetchedAllChannelsSuccess && fetchSingleAgentSuccess) {
            // setSelectedMarketingConnection(fetchedAllChannelsSuccess?.channel);

            if (
                fetchSingleAgentSuccess?.type === "marketingCampaign" &&
                !savedData?.type &&
                !hasSavedData
            ) {
                if (
                    typeof fetchSingleAgentSuccess?.activeAgent === "object" &&
                    fetchSingleAgentSuccess?.activeAgent?._id
                ) {
                    const connectedChannels = fetchedAllChannelsSuccess?.channel?.find(
                        (item) =>
                            item?._id ===
                            fetchSingleAgentSuccess?.activeAgent?.communicationChannel
                                ?.socialChannels?.[0]?.socialId
                    );
                    setSourceActionTrigger(connectedChannels?.channel || "");
                }
            }

            if (
                fetchSingleAgentSuccess?.type === "EDIAssistant" &&
                !savedData?.type &&
                !hasSavedData
            ) {
                if (
                    typeof fetchSingleAgentSuccess?.activeAgent === "object" &&
                    fetchSingleAgentSuccess?.activeAgent?._id
                ) {
                    const socialChannels = fetchedAllChannelsSuccess?.channel?.filter(
                        (item) =>
                            item?._id ===
                            fetchSingleAgentSuccess?.activeAgent?.communicationChannel
                                ?.socialChannels?.[0]?.socialId
                    );
                    setSelectedMarketingConnection([
                        {
                            name: "SPS Commerce",
                            connection: socialChannels,
                            key: "spsCommerce",
                        },
                    ]);
                }
            }
        }
    }, [fetchedAllChannelsSuccess, fetchSingleAgentSuccess, savedData, hasSavedData]);

    useEffect(() => {
        if (fetchSingleAgentSuccess) {
            const activeAgent =
                typeof fetchSingleAgentSuccess?.activeAgent === "object" &&
                fetchSingleAgentSuccess?.activeAgent?._id;
            setAgentIsActive(activeAgent);

            if (!savedData?.type && !hasSavedData) {
                setAvatar(
                    fetchSingleAgentSuccess?.type === "orderProcessing" && !activeAgent
                        ? "https://storage.googleapis.com/heysynth_files/synth_webapp/AI_Teammate_1_ure13x.svg"
                        : fetchSingleAgentSuccess?.type === "EDIAssistant" && !activeAgent
                        ? "https://storage.googleapis.com/heysynth_files/synth_webapp/ai_avatar_light_blue_ka09qw.svg"
                        : fetchSingleAgentSuccess?.type === "InventoryManagement" && !activeAgent
                        ? "https://storage.googleapis.com/heysynth_files/synth_webapp/ai_avatar_maroon_t6py13.svg"
                        : !activeAgent
                        ? "https://storage.googleapis.com/heysynth_files/synth_webapp/ai_avatar_orange_llneem.svg"
                        : fetchSingleAgentSuccess?.activeAgent?.avatar
                );

                setCreateOrderActionStep([
                    {
                        label: "No Action",
                        value: "",
                    },
                    ...(fetchSingleAgentSuccess?.steps
                        ?.find((step) => step?.key === "order_create")
                        ?.actions?.map((action) => {
                            return {
                                label: camelCaseToRegularCase(action?.name),
                                value: action?.name,
                            };
                        }) || []),
                ]);
            }

            // order processing agent create || edi assistant agent create
            if (
                (fetchSingleAgentSuccess?.type === "orderProcessing" ||
                    fetchSingleAgentSuccess?.type === "EDIAssistant") &&
                !savedData?.type &&
                !hasSavedData
            ) {
                // for update :order processing agent
                if (
                    typeof fetchSingleAgentSuccess?.activeAgent === "object" &&
                    fetchSingleAgentSuccess?.activeAgent?._id &&
                    (fetchSingleAgentSuccess?.type === "orderProcessing" ||
                        fetchSingleAgentSuccess?.type === "EDIAssistant")
                ) {
                    const getStepWithAdditionalEmails =
                        fetchSingleAgentSuccess?.activeAgent?.steps?.find(
                            (step) =>
                                step?.key === "order_create" &&
                                step?.actions?.[0]?.externalSystem === "email"
                        );
                    setValueArray(
                        getStepWithAdditionalEmails?.actions?.[0]?.externalSystemPayload?.to
                            ?.length > 0
                            ? getStepWithAdditionalEmails?.actions?.[0]?.externalSystemPayload?.to
                            : []
                    );
                    setAgentDetails(fetchSingleAgentSuccess);
                    setEmailClientSocialId(
                        fetchSingleAgentSuccess?.activeAgent?.communicationChannel
                            ?.emailChannels?.[0]?.socialId || ""
                    );

                    setAiAgentName(fetchSingleAgentSuccess?.activeAgent?.teamMateName);
                    setSourceActionTrigger(
                        fetchSingleAgentSuccess?.activeAgent?.communicationChannel?.email
                            ? "email"
                            : "auto_generate_email"
                    );
                    const getInvCheck = fetchSingleAgentSuccess?.activeAgent?.steps
                        ?.find((step) => step?.key === "inventory_check")
                        ?.actions?.find((item) => item.selected)?.name;

                    setSelectedAction(getInvCheck);

                    setAgentSteps([
                        {
                            key: "name-agent",
                            configured: true,
                            title: "Name your AI Agent",
                            actionText: "Agent name",
                        },
                        {
                            key: "source-action-tigger",
                            configured: true,
                            title: "Select the source - action trigger",
                            actionText:
                                fetchSingleAgentSuccess?.type === "EDIAssistant"
                                    ? ""
                                    : "Order source email",
                        },
                        ...(fetchSingleAgentSuccess?.activeAgent?.steps?.length > 0 &&
                            fetchSingleAgentSuccess?.activeAgent?.steps?.map((step) => {
                                return {
                                    ...step,
                                    showApproval: fetchSingleAgentSuccess?.steps?.find(
                                        (st) => st?.key === step?.key
                                    )?.approvalPossible
                                        ? true
                                        : false,
                                    approvalPossible: step?.approvalPossible,
                                    configured: step?.customInstructions
                                        ? true
                                        : step?.actions?.length > 0 &&
                                          step?.actions?.find((action) => action?.selected)
                                        ? true
                                        : false,
                                    approverName: step?.approvalId?.email || "",
                                    isActive: step?.isActive ?? true,
                                    isEnabled: fetchSingleAgentSuccess?.steps?.find(
                                        (st) => st?.key === step?.key
                                    )?.isEnabled,
                                    ...(step?.key === "order_create" && step?.actions?.length === 0
                                        ? {
                                              actions: fetchSingleAgentSuccess?.steps?.find(
                                                  (step) => step?.key === "order_create"
                                              )?.actions,
                                          }
                                        : { actions: step?.actions }),
                                };
                            })),
                    ]);

                    setCreateOrderAction(
                        fetchSingleAgentSuccess?.activeAgent?.steps
                            ?.find((step) => step?.key === "order_create")
                            ?.actions?.find((action) => action?.selected)?.name || ""
                    );
                } else if (
                    fetchSingleAgentSuccess?.type === "orderProcessing" ||
                    fetchSingleAgentSuccess?.type === "EDIAssistant"
                ) {
                    // for create order processing agent
                    setAgentDetails(fetchSingleAgentSuccess);
                    setAgentSteps([
                        {
                            key: "name-agent",
                            configured: false,
                            title: "Name your AI Agent",
                            actionText: "Agent name",
                            agentName: "",
                            btnTypes: ["approval"],
                        },
                        {
                            key: "source-action-tigger",
                            configured: false,
                            title: "Select the source - action trigger",
                            actionText:
                                fetchSingleAgentSuccess?.type === "EDIAssistant"
                                    ? ""
                                    : "Order source email",
                            agentEmail: "",
                        },
                        ...(fetchSingleAgentSuccess?.steps?.length > 0 &&
                            fetchSingleAgentSuccess?.steps?.map((step) => {
                                return {
                                    ...step,
                                    showApproval:
                                        step.key === "order_email_send"
                                            ? true
                                            : step?.approvalPossible,
                                    approvalPossible:
                                        step.key === "order_email_send" ? true : false,
                                    isActive: true,
                                    isEnabled: step?.isEnabled,
                                };
                            })),
                    ]);
                }
            }

            // // marketing campaign agent
            if (
                fetchSingleAgentSuccess?.type === "marketingCampaign" &&
                !savedData?.type &&
                !hasSavedData
            ) {
                if (
                    fetchSingleAgentSuccess?.activeAgent === "object" &&
                    fetchSingleAgentSuccess?.activeAgent?._id
                ) {
                    setAiAgentName(fetchSingleAgentSuccess?.activeAgent?.teamMateName || "");
                    const connectedChannels = fetchedAllChannelsSuccess?.channel?.find(
                        (item) =>
                            item?._id ===
                            fetchSingleAgentSuccess?.activeAgent?.communicationChannel
                                ?.socialChannels?.[0]?.socialId
                    );
                    setSourceActionTrigger(connectedChannels?.channel || "");
                }
                setAgentDetails(fetchSingleAgentSuccess);
                setAgentSteps([
                    {
                        key: "name-agent",
                        title: "Name your AI Agent",
                        actionText: "Agent name",
                        configured: fetchSingleAgentSuccess?.activeAgent?._id ? true : false,
                        overviewText:
                            "This team-mate ensures planned and ongoing campaigns are backed by sufficient inventory, avoiding stock-outs and maximizing revenue.",
                    },
                    {
                        key: "source-action-tigger",
                        title: "Select the source - action trigger",
                        configured: fetchSingleAgentSuccess?.activeAgent?._id ? true : false,
                    },
                ]);
            }

            //inventory management agent

            if (
                fetchSingleAgentSuccess?.type === "InventoryManagement" &&
                !savedData?.type &&
                !hasSavedData
            ) {
                setAiAgentName(fetchSingleAgentSuccess?.activeAgent?.teamMateName || "");
                setAgentDetails(fetchSingleAgentSuccess);
                if (
                    typeof fetchSingleAgentSuccess?.activeAgent === "object" &&
                    fetchSingleAgentSuccess?.activeAgent?._id
                ) {
                    setSourceActionTrigger(
                        fetchSingleAgentSuccess?.activeAgent?.communicationChannel?.email
                            ? "email"
                            : "auto_generate_email"
                    );

                    setAgentDetails(fetchSingleAgentSuccess);
                    setEmailClientSocialId(
                        fetchSingleAgentSuccess?.activeAgent?.communicationChannel
                            ?.emailChannels?.[0]?.socialId || ""
                    );

                    setAiAgentName(fetchSingleAgentSuccess?.activeAgent?.teamMateName);
                    setSourceActionTrigger(
                        fetchSingleAgentSuccess?.activeAgent?.communicationChannel?.email
                            ? "email"
                            : "auto_generate_email"
                    );
                    const getInvCheck = fetchSingleAgentSuccess?.activeAgent?.steps
                        ?.find((step) => step?.key === "update_inventory")
                        ?.actions?.find((item) => item.selected)?.name;

                    setSelectedAction(getInvCheck);

                    setAgentSteps([
                        {
                            key: "name-agent",
                            configured: true,
                            title: "Name your AI Agent",
                            actionText: "Agent name",
                        },
                        {
                            key: "source-action-tigger",
                            configured: true,
                            title: "Select the source - action trigger",
                            actionText:
                                fetchSingleAgentSuccess?.type === "EDIAssistant"
                                    ? ""
                                    : "Order source email",
                        },
                        ...(fetchSingleAgentSuccess?.activeAgent?.steps?.length > 0 &&
                            fetchSingleAgentSuccess?.activeAgent?.steps?.map((step) => {
                                return {
                                    ...step,
                                    showApproval: step?.approvalPossible,
                                    approvalPossible: step?.approvalPossible,
                                    configured: step?.customInstructions
                                        ? true
                                        : step?.actions?.length > 0 &&
                                          step?.actions?.find((action) => action?.selected)
                                        ? true
                                        : false,
                                    approverName: step?.approvalId?.email || "",
                                    isActive: step?.isActive ?? true,
                                    isEnabled: fetchSingleAgentSuccess?.steps?.find(
                                        (st) => st?.key === step?.key
                                    )?.isEnabled,
                                    actions: step?.actions?.length > 0 ? step?.actions : [],
                                };
                            })),
                    ]);
                } else {
                    setAgentDetails(fetchSingleAgentSuccess);

                    setAgentSteps([
                        {
                            key: "name-agent",
                            title: "Name your AI Agent",
                            actionText: "Agent name",
                            configured: fetchSingleAgentSuccess?.activeAgent?._id ? true : false,
                        },
                        {
                            key: "source-action-tigger",
                            configured: false,
                            title: "Select the source - action trigger",
                            actionText: "Inventory report source email",
                        },
                        ...(fetchSingleAgentSuccess?.steps?.length > 0 &&
                            fetchSingleAgentSuccess?.steps?.map((step) => {
                                return {
                                    ...step,
                                    showApproval: step?.approvalPossible,
                                    approvalPossible: step?.approvalPossible,
                                    isActive: true,
                                    isEnabled: step?.isEnabled,
                                };
                            })),
                    ]);
                }
            }

            dispatch(workforceActions.resetGetSingleAgentSuccess());
        }

        if (savedData?.type && !hasSavedData) {
            if (savedData?.type === "orderProcessing") {
                setAgentIsActive(savedData?.agentIsActive);
                setAvatar(savedData?.avatar);
                setValueArray(savedData?.valueArray);
                setAgentDetails(savedData?.agentDetails);
                setEmailClientSocialId(savedData?.emailClientSocialId);
                setAiAgentName(savedData?.aiAgentName);
                setSourceActionTrigger(savedData?.sourceActionTrigger);
                setSelectedAction(savedData?.selectedAction);
                setAgentSteps(savedData?.agentSteps);
            }
            if (savedData?.type === "marketingCampaign") {
                setAiAgentName(savedData?.aiAgentName);
                setSourceActionTrigger(savedData?.sourceActionTrigger);
                setAgentDetails(savedData?.agentDetails);
                setAgentSteps(savedData?.agentSteps);
                setAvatar(savedData?.avatar);
            }
            if (savedData?.type === "InventoryManagement") {
                setAiAgentName(savedData?.aiAgentName);
                setSourceActionTrigger(savedData?.sourceActionTrigger);
                setAgentDetails(savedData?.agentDetails);
                setAgentSteps(savedData?.agentSteps);
                setAgentIsActive(savedData?.agentIsActive);
                setAvatar(savedData?.avatar);
                setEmailClientSocialId(savedData?.emailClientSocialId);
                setSelectedAction(savedData?.selectedAction);
            }

            if (savedData?.type === "EDIAssistant") {
                setAiAgentName(savedData?.aiAgentName);
                setSelectedMarketingConnection(savedData?.selectedMarketingConnection);
                setAgentDetails(savedData?.agentDetails);
                setAgentSteps(savedData?.agentSteps);
                setAvatar(savedData?.avatar);
            }

            removeFromStorage("connectedRedirect");
            removeFromStorage("createAiAgentForm");
            setHasSavedData(true);
        }
    }, [dispatch, fetchSingleAgentSuccess, savedData, hasSavedData, fetchedAllChannelsSuccess]);

    const emailClients = fetchedAllChannelsSuccess?.channel?.filter(
        (item) =>
            (item?.channel?.toLowerCase() === "gmail" ||
                item?.channel?.toLowerCase() === "microsoft") &&
            item?.active
    );

    useEffect(() => {
        if (currentStep) {
            const stepIndex = agentSteps?.findIndex((step) => step?.key === currentStep);
            if (stepIndex !== -1) {
                setCurrentStepIndex(stepIndex);
            }
        }
    }, [currentStep, agentSteps]);

    const dummyEmail =
        (aiAgentName || "astra").trim().toLowerCase().split(" ").join("_") +
        "-" +
        (profile?.profile?.businessName?.trim().toLowerCase().split(" ").join("_") ?? "") +
        "@agents.heysynth.com";

    // const toEmailPattern = (str: string) => str.trim().toLowerCase().split(" ").join("_");
    // const emailPattern = `${toEmailPattern(aiAgentName || "astra")}-${toEmailPattern(
    //     profile?.profile?.businessName ?? ""
    // )}`;
    // const dummyEmail = `${emailPattern}@agents.heysynth.com`;

    const handleAgentStepChange = (
        currentStepIndex: number,
        name: string,
        value: string | boolean
    ) => {
        const newAgentSteps = [...agentSteps];
        if (currentStepIndex !== -1) {
            newAgentSteps[currentStepIndex] = {
                ...newAgentSteps[currentStepIndex],
                [name]: value,
                ...(name === "customInstructions" && {
                    configured: value ? true : false,
                }),
            };
        }
        setAgentSteps(newAgentSteps);
    };

    const handleApproverChange = (value: string) => {
        const newAgentSteps = [...agentSteps];
        if (value) {
            const filteredData = teamMembers.filter((item) => item._id === value);
            const newAgentSteps = [...agentSteps];
            if (currentStepIndex !== -1) {
                newAgentSteps[currentStepIndex] = {
                    ...newAgentSteps[currentStepIndex],
                    approvalIdString: value,
                    approverName: filteredData?.[0]?.email || filteredData?.[0]?.fullName || "",
                    configured:
                        agentSteps[currentStepIndex]?.approvalPossible && value ? true : false,
                };
            }
            setAgentSteps(newAgentSteps);
        } else {
            if (currentStepIndex !== -1) {
                newAgentSteps[currentStepIndex] = {
                    ...newAgentSteps[currentStepIndex],
                    approvalIdString: "",
                    approverName: value,
                    configured: false,
                };
            }
            setAgentSteps(newAgentSteps);
        }
    };

    const handleMultipleEmails = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setAdditionalEmails(value);
    };

    const handleActionChange = (currentStepIndex: number, name: string, value: string) => {
        const newAgentSteps = [...agentSteps];

        if (name === "body") {
            newAgentSteps[currentStepIndex].actions[0] = {
                ...newAgentSteps[currentStepIndex]?.actions[0],
                externalSystemPayload: {
                    ...newAgentSteps[currentStepIndex]?.actions[0]?.externalSystemPayload,
                    body: value,
                },
            };
        } else {
            newAgentSteps[currentStepIndex].actions[0] = {
                ...newAgentSteps[currentStepIndex]?.actions[0],
                [name]: value,
                // selected: value ? true : false, /// thoughts here
            };
        }
        setAgentSteps(newAgentSteps);
    };

    const handleCreateAgent = () => {
        if (additionalEmails && !emailRegex.test(additionalEmails)) {
            toast.custom((t) => (
                <CustomToast t={t} message={"Please enter a valid email address"} type={"error"} />
            ));
            return;
        }

        if (!aiAgentName) {
            toast.custom((t) => (
                <CustomToast t={t} message={"Please enter the agent name"} type={"error"} />
            ));
            setCurrentStep("name-agent");
            return;
        }
        if (
            (agentDetails?.type !== "EDIAssistant" && !sourceActionTrigger) ||
            (agentDetails?.type === "EDIAssistant" && selectedMarketingConnection?.length === 0)
        ) {
            toast.custom((t) => (
                <CustomToast
                    t={t}
                    message={"Please select a source action trigger"}
                    type={"error"}
                />
            ));
            setCurrentStep("source-action-tigger");
            return;
        }

        if (
            !selectedAction &&
            (agentDetails?.type === "orderProcessing" || agentDetails?.type === "EDIAssistant")
        ) {
            toast.custom((t) => (
                <CustomToast t={t} message={"Please, select control action"} type={"error"} />
            ));
            setCurrentStep("inventory_check");
            return;
        }
        const findNoApprovalString = agentSteps?.find(
            (step) => step?.approvalPossible === true && !step?.approvalIdString
        );
        const getCurrentIndex = findNoApprovalString?.key;

        if (getCurrentIndex !== undefined) {
            toast.custom((t) => (
                <CustomToast
                    t={t}
                    message={"Approval is turned on for this step, please select an approver"}
                    type={"error"}
                />
            ));
            setCurrentStep(getCurrentIndex);
            return;
        }
        const createOrderCheck = agentSteps?.find(
            (step) => step?.key === "order_create" && createOrderAction
        );

        if (createOrderCheck) {
            if (
                createOrderCheck?.actions?.[0]?.approvalPossible &&
                !createOrderCheck?.actions?.[0]?.approvalIdString
            ) {
                setCurrentStep("order_create");

                toast.custom((t) => (
                    <CustomToast
                        t={t}
                        message={
                            "Approval is turned on for generate sales orders action, please select an approver"
                        }
                        type={"error"}
                    />
                ));
                return;
            } else if (
                createOrderAction &&
                (!createOrderCheck?.actions?.[0]?.externalSystem ||
                    (createOrderCheck?.actions?.[0]?.externalSystem === "email" &&
                        valueArray?.length === 0 &&
                        !additionalEmails) ||
                    (createOrderCheck?.actions?.[0]?.externalSystem === "email" &&
                        !createOrderCheck?.actions?.[0]?.externalSystemPayload?.body))
            ) {
                setCurrentStep("order_create");

                toast.custom((t) => (
                    <CustomToast
                        t={t}
                        message={
                            createOrderCheck?.actions?.[0]?.externalSystem === "email" &&
                            !createOrderCheck?.actions?.[0]?.externalSystemPayload?.body
                                ? "Custom message is required for email external system transfer"
                                : createOrderCheck?.actions?.[0]?.externalSystem === "email" &&
                                  valueArray?.length === 0 &&
                                  !additionalEmails
                                ? "Email address is required for email external system transfer"
                                : "External system is required for generate sales orders action, please select an external system"
                        }
                        type={"error"}
                    />
                ));
                return;
            }
        }

        //marketing campaign social Id
        const socialId = fetchedAllChannelsSuccess?.channel?.find(
            (item) => item?.channel?.toLowerCase() === sourceActionTrigger && item?.active
        );

        const newArray = [...agentSteps];

        //configure steps for order processing, inventory management, edi assistant
        const steps = newArray?.splice(2).map((step) => {
            return {
                name: step?.name,
                key: step?.key,
                title: step?.title,
                description: step?.description,
                approvalPossible: step?.approvalPossible,
                repeatable: step?.repeatable,
                ...(step?.approvalPossible && { approvalIdString: step?.approvalIdString }),
                ...(step?.customInstructions && { customInstructions: step?.customInstructions }),
                isActive: step?.isActive,
                actions:
                    step?.key === "order_create" && step?.actions?.length > 0 && createOrderAction
                        ? [
                              {
                                  description: step?.actions?.[0]?.description,
                                  name: step?.actions?.[0]?.name,
                                  selected: createOrderAction ? true : false,
                                  approvalIdString: step?.actions?.[0]?.approvalIdString,
                                  approvalPossible: step?.actions?.[0]?.approvalIdString
                                      ? true
                                      : false,
                                  customInstructions: step?.actions?.[0]?.customInstructions,
                                  ...(step?.actions?.[0]?.externalSystem && {
                                      externalSystem: step?.actions?.[0]?.externalSystem,
                                  }),
                                  ...(step?.actions?.[0]?.externalSystem === "email" &&
                                      step?.actions?.[0]?.approvalPossible &&
                                      step?.actions?.[0]?.approvalIdString && {
                                          approvalIdString: step?.actions?.[0]?.approvalIdString,
                                      }),
                                  ...(step?.actions?.[0]?.externalSystem === "email" && {
                                      externalSystemPayload: {
                                          ...step?.actions?.[0]?.externalSystemPayload,
                                          ...(additionalEmails && emailRegex.test(additionalEmails)
                                              ? {
                                                    to: [...valueArray, additionalEmails],
                                                }
                                              : {
                                                    to: valueArray?.length > 0 ? valueArray : [],
                                                }),
                                      },
                                  }),
                              },
                          ]
                        : step?.key === "order_create" && !createOrderAction
                        ? []
                        : step?.actions?.length > 0
                        ? step?.actions?.map((action) => {
                              return {
                                  name: action?.name,
                                  description: action?.description,
                                  selected: selectedAction === action?.name ? true : false,
                              };
                          })
                        : [],
            };
        });

        const body = {
            teamMateName: aiAgentName,
            ...(!agentIsActive && { agentType: agentDetails?.type }),
            ...(!agentIsActive && { agentId: agentDetails?._id }),
            //set link here
            avatar: avatar,
            communicationChannel: {
                email:
                    agentDetails?.type === "orderProcessing" ||
                    agentDetails?.type === "InventoryManagement"
                        ? sourceActionTrigger === "email"
                            ? true
                            : false
                        : false,
                inApp: false,
                autoGenerateEmail:
                    agentDetails?.type === "orderProcessing" ||
                    agentDetails?.type === "InventoryManagement"
                        ? sourceActionTrigger === "auto_generate_email"
                            ? true
                            : false
                        : false,
                ...((agentDetails?.type === "orderProcessing" ||
                    agentDetails?.type === "InventoryManagement") &&
                    emailClientSocialId &&
                    sourceActionTrigger === "email" &&
                    agentIsActive && {
                        emailChannels: [{ socialId: emailClientSocialId }],
                    }),
                ...(agentDetails?.type === "marketingCampaign" && {
                    socialChannels: [
                        {
                            socialId: socialId?._id,
                        },
                    ],
                    ...(agentDetails?.type === "EDIAssistant" && {
                        socialChannels: selectedMarketingConnection?.map((item) => ({
                            socialId: item?.connection?._id,
                        })),
                    }),
                }),
            },
            ...((agentDetails?.type === "orderProcessing" ||
                agentDetails?.type === "EDIAssistant" ||
                agentDetails?.type === "InventoryManagement") && { steps }),
            ...(agentDetails?.type === "marketingCampaign" && {
                steps: agentDetails?.steps?.map((step) => {
                    return {
                        name: step?.name,
                        key: step?.key,
                        title: step?.title,
                        description: step?.description,
                        approvalPossible: step?.approvalPossible,
                        repeatable: step?.repeatable,
                        actions: step?.actions?.length > 0 ? step?.actions : [],
                    };
                }),
            }),
        };

        if (agentIsActive) {
            dispatch(workforceActions.updateAiTeammate(body, agentDetails?.activeAgent?._id));
        } else {
            dispatch(workforceActions.createAiTeammate(body));
        }
    };

    //update agent icon

    useEffect(() => {
        if (createAiTeammateSuccess) {
            setAiTeammateId(createAiTeammateSuccess?._id);
            setSuccessModal(true);
            dispatch(workforceActions.resetCreateAiTeammateSuccess());
            removeFromStorage("createAiAgentForm");
            setCurrentStep("");
        }
        if (updateAiTeammateSuccess) {
            dispatch(workforceActions.resetUpdateAiTeammateSuccess());
            removeFromStorage("createAiAgentForm");
            setCurrentStep("");
        }
    }, [dispatch, createAiTeammateSuccess, updateAiTeammateSuccess]);

    const handleStepConfiguration = (value: boolean) => {
        const newAgentSteps = [...agentSteps];
        newAgentSteps[currentStepIndex] = {
            ...newAgentSteps[currentStepIndex],
            configured: value ? true : false,
        };
        setAgentSteps(newAgentSteps);
    };

    const handleUpload = (fileName, file, currentStepIndex) => {
        setUploadingDoc(true);
        firebaseService.uploadFile(
            `synthally/${process.env.REACT_APP_STAGE}/ai-teammate-docs/${fileName}`,
            file,
            (url) => {
                setAgentSteps((prev) => {
                    const updated = [...prev];
                    const action = updated[currentStepIndex]?.actions?.[0];

                    if (action) {
                        action.externalSystemPayload = action.externalSystemPayload || {};
                        action.externalSystemPayload.attachments =
                            action.externalSystemPayload.attachments || [];

                        action.externalSystemPayload.attachments.push({
                            filename: fileName,
                            path: url,
                        });
                    }

                    return updated;
                });

                setUploadingDoc(false);
            }
        );
    };

    const deleteAttachment = (currentStepIndex, idx) => {
        const newAgentSteps = [...agentSteps];
        newAgentSteps[currentStepIndex].actions[0].externalSystemPayload.attachments?.splice(
            idx,
            1
        );
        setAgentSteps(newAgentSteps);
    };

    const { goBack } = useNavigationHandler({ fallbackPath: "/dashboard/workforce" });

    const getSourceActionTrigger = (source: string) => {
        switch (source) {
            case "tiktok_ads":
                return {
                    name: "TikTok Ads",
                    icon: "https://storage.googleapis.com/heysynth_files/synth_webapp/tiktok_logo.webp",
                };
            case "klaviyo":
                return {
                    name: "Klaviyo",
                    icon: "https://storage.googleapis.com/heysynth_files/synth_webapp/Klaviyo_symbol_zynlc7.webp",
                };
            case "google_ads":
                return {
                    name: "Google Ads",
                    icon: "https://storage.googleapis.com/heysynth_files/synth_webapp/google-ads_syiiti.svg",
                };
            default:
                return {
                    name: "",
                    icon: "",
                };
        }
    };

    const handleUploadAvatar = (fileName, file) => {
        setUploadingAvatar(true);
        firebaseService.uploadFile(
            `synthally/${process.env.REACT_APP_STAGE === "production" ? "production" : "staging"}/${
                profile?.user?.profile?.businessName
            }/aiTeammateAvatar/${fileName}`,
            file,
            (url) => {
                setAvatar(url);
                setUploadingAvatar(false);
                setOpenAvatarModal(false);
            }
        );
    };

    useEffect(() => {
        let lastActiveIndex = -1;
        for (let i = agentSteps.length - 1; i >= 0; i--) {
            if (agentSteps[i].isActive === true) {
                lastActiveIndex = i;
                break;
            }
        }
        setLastActiveIndex(lastActiveIndex !== -1 ? lastActiveIndex : 1);
    }, [agentSteps]);

    return (
        <div>
            {!openPreview ? (
                <>
                    <div className="sticky top-[-20px] z-[1200] bg-white ">
                        <div
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                            className="rounded-t-[8px]"
                        >
                            <div className="flex items-center justify-between px-4 py-3 border-b border-slate-100 text-sm ">
                                <div className="flex items-center space-x-1.5 text-slate-400 text-sm font-rocGroteskMedium">
                                    <i
                                        onClick={() => {
                                            goBack();
                                        }}
                                        className="ri-arrow-left-s-line text-lg mt-[-2px] text-slate-400 py-0 px-1 rounded-full bg-slate-100 cursor-pointer"
                                    ></i>
                                    <span className="">AI teammate</span>
                                    {agentDetails?.type && (
                                        <span className="">
                                            / {getAgentName(agentDetails?.type)}
                                        </span>
                                    )}

                                    {aiAgentName && (
                                        <span className="text-slate-900 font-rocGroteskMedium">
                                            / {aiAgentName}
                                        </span>
                                    )}
                                </div>
                                <div className="flex items-center space-x-3">
                                    {/* {(agentDetails?.type === "orderProcessing" ||
                                        agentDetails?.type === "EDIAssistant") && ( */}
                                    {agentDetails?.type === "orderProcessing" && (
                                        <Button
                                            btnText="Preview"
                                            btnClassname="!px-4 !py-2.5 !bg-tradeally-neutral-20 !w-fit"
                                            disabled={false}
                                            onClick={() => {
                                                setOpenPreview(true);
                                                if (agentId) {
                                                    saveToStorage(
                                                        "connectedRedirect",
                                                        `/dashboard/workforce/ai-teammate/non-active/${agentId}`
                                                    );
                                                } else {
                                                    saveToStorage(
                                                        "connectedRedirect",
                                                        `/dashboard//workforce/ai-teammate/${aiTeammateId}/${agentId}`
                                                    );
                                                }
                                                saveToStorage(
                                                    "createAiAgentForm",
                                                    {
                                                        agentIsActive,
                                                        avatar,
                                                        valueArray,
                                                        agentDetails,
                                                        emailClientSocialId,
                                                        aiAgentName,
                                                        sourceActionTrigger,
                                                        selectedAction,
                                                        agentSteps,
                                                        type: "orderProcessing",
                                                    },
                                                    true
                                                );
                                            }}
                                        />
                                    )}
                                    <Button
                                        btnText={agentIsActive ? "Update Agent" : "Create Agent"}
                                        btnPermission={[]}
                                        type="button"
                                        onClick={() => {
                                            handleCreateAgent();
                                        }}
                                        isLoading={creatingAiTeammate || updatingAiTeammate}
                                        disabled={false}
                                        btnClassname="!px-4 !py-2.5 !w-fit"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="">
                            <Tabs setActiveTab={setActiveTab} activeTab={activeTab} />
                        </div>
                    </div>
                    <div className=" bg-[url('https://storage.googleapis.com/heysynth_files/synth_webapp/Background%20pattern%20-%20dots.svg')] bg-repeat bg-cover">
                        {fetchingSingleAgent ? (
                            <div className=" h-[500px] flex items-center justify-center">
                                <Loader />
                            </div>
                        ) : (
                            <div
                                className="flex flex-col items-center"
                                onClick={() => {
                                    setCurrentStep("");
                                }}
                            >
                                <div className="py-8">
                                    {agentSteps?.map((step, idx) => {
                                        return (
                                            <div key={idx}>
                                                {idx === 0 && (
                                                    <div className="flex items-center gap-1 text-[#16A34A] bg-[#DCFCE7] px-2 py-1 rounded-t-md !w-fit">
                                                        <i className="ri-play-mini-fill text-[#16A34A] text-xs"></i>
                                                        <p className="text-sm ">Start</p>
                                                    </div>
                                                )}
                                                <div
                                                    className={` w-[537px] ${
                                                        idx === 2 && "rounded-t pt-4"
                                                    } ${
                                                        agentSteps?.length - 1 === idx &&
                                                        "rounded-b pb-4"
                                                    } ${idx > 1 && "bg-[#F3F7FA]"}`}
                                                >
                                                    {idx === 2 && (
                                                        <div className="px-4">
                                                            <p className="text-base font-rocGroteskMedium text-slate-800 mb-2">
                                                                AI Teammate's customization
                                                            </p>
                                                        </div>
                                                    )}
                                                    <div
                                                        className={`flex items-center ${
                                                            (step?.isEnabled ||
                                                                lastActiveIndex === idx) &&
                                                            "justify-between mt-[-20px]"
                                                        }`}
                                                    >
                                                        {lastActiveIndex === idx ? (
                                                            <div
                                                                className={` flex items-center gap-1 text-[#16A34A] bg-[#DCFCE7] px-2 py-1 rounded-t-md !w-fit ${
                                                                    lastActiveIndex > 1 && "mx-4 "
                                                                } ${
                                                                    lastActiveIndex === 2 && "mt-2"
                                                                }`}
                                                            >
                                                                <i className="ri-stop-fill text-[#16A34A] text-xs"></i>
                                                                <p className="text-sm ">End</p>
                                                            </div>
                                                        ) : (
                                                            <div className=""></div>
                                                        )}

                                                        {step?.isEnabled && (
                                                            <div
                                                                className={`flex items-center gap-2 mb-1 mx-4 ${
                                                                    !step?.isActive &&
                                                                    step?.isEnabled &&
                                                                    "opacity-[50%]"
                                                                } `}
                                                            >
                                                                <p className="text-slate-800 text-[13px] font-rocGroteskMedium">
                                                                    Turn{" "}
                                                                    {step?.isActive ? "off" : "on"}{" "}
                                                                    step
                                                                </p>

                                                                <ToggleInput
                                                                    checked={
                                                                        step?.isActive as boolean
                                                                    }
                                                                    name={"isActive"}
                                                                    onChange={(e) => {
                                                                        const newSteps = [
                                                                            ...agentSteps,
                                                                        ];
                                                                        newSteps[idx].isActive =
                                                                            e.target.checked;
                                                                        setAgentSteps(newSteps);
                                                                    }}
                                                                    className="before:!h-4 before:!w-4 h-5 w-[30px] before:left-[2px] rounded-[30px] s-slider"
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div
                                                        className={` ${
                                                            idx > 1 &&
                                                            "bg-[#F3F7FA] px-4 rounded-xl"
                                                        } flex flex-col justify-center items-center font-rocGroteskMedium`}
                                                    >
                                                        <div
                                                            className={`hover:border-[#FFB902] hover:border-2 border-slate-200 border w-full rounded-x-lg rounded-tr-lg rounded-b-lg p-3 bg-white ${
                                                                idx === 0 ||
                                                                idx === agentSteps?.length - 1
                                                                    ? "!rounded-tl-0"
                                                                    : "rounded-tl-lg"
                                                            } ${
                                                                !step?.isActive &&
                                                                step?.isEnabled &&
                                                                "opacity-[50%]"
                                                            } `}
                                                        >
                                                            <div className="">
                                                                <div className="border-b border-b-slate-200 ">
                                                                    <div className="w-full flex items-center justify-between">
                                                                        <p className="text-sm text-slate-800">
                                                                            {step?.title}
                                                                        </p>
                                                                        {step?.key !==
                                                                            "order_extraction" && (
                                                                            <div className="flex gap-1 items-center">
                                                                                {step?.configured ? (
                                                                                    <i className="ri-checkbox-circle-fill text-g-50 text-base"></i>
                                                                                ) : (
                                                                                    <i className="ri-close-circle-fill text-[#E4281D] text-base"></i>
                                                                                )}

                                                                                {step?.configured ? (
                                                                                    <p className="text-xs text-slate-500">
                                                                                        Configured
                                                                                    </p>
                                                                                ) : (
                                                                                    <p className="text-xs text-slate-500">
                                                                                        Not
                                                                                        Configured
                                                                                    </p>
                                                                                )}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    {step?.optional && (
                                                                        <div className="flex gap-0.5 items-center">
                                                                            <SynthTooltip
                                                                                divId={`identify-order`}
                                                                                position={"top"}
                                                                                icon={
                                                                                    <i className="ri-information-fill text-[#DDA000] text-sm"></i>
                                                                                }
                                                                                // contentIcon={<></>}
                                                                                title=""
                                                                                content={
                                                                                    step?.description
                                                                                }
                                                                                styling={{
                                                                                    width: "270px",
                                                                                    background:
                                                                                        "#142837",
                                                                                    borderRadius:
                                                                                        "6px",
                                                                                }}
                                                                                contentClass="text-[#89939b]"
                                                                            />
                                                                            <p className="text-sm text-[#DDA000]">
                                                                                This step is
                                                                                optional
                                                                            </p>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div className="pt-2">
                                                                <p className="text-sm text-slate-500">
                                                                    {step?.actionText}
                                                                </p>

                                                                {step?.key ===
                                                                    "order_extraction" && (
                                                                    <div className="flex items-center gap-2">
                                                                        <p className="text-sm text-slate-500">
                                                                            {step?.description}
                                                                        </p>
                                                                    </div>
                                                                )}
                                                                <div className="flex items-center gap-2 justify-between mt-2">
                                                                    {step?.key === "name-agent" ? (
                                                                        <div
                                                                            className={`flex items-center gap-2  px-2.5 py-1.5 rounded-md 
                                                                                ${
                                                                                    agentDetails?.type ===
                                                                                    "orderProcessing"
                                                                                        ? "bg-[#6562E51A] text-p-50"
                                                                                        : agentDetails?.type ===
                                                                                          "EDIAssistant"
                                                                                        ? "bg-[#00C6FA1A] text-[#00C6FA]"
                                                                                        : agentDetails?.type ===
                                                                                          "InventoryManagement"
                                                                                        ? "bg-[#B9017A1A] text-[#B9017A]"
                                                                                        : "bg-[#FFEDD5] text-[#EA580C]"
                                                                                }
                                                                                `}
                                                                        >
                                                                            <div className="w-4 h-4 flex items-center justify-center  ">
                                                                                <img
                                                                                    src={avatar}
                                                                                    alt="avatar"
                                                                                    className="w-4 h-4 rounded-full"
                                                                                />
                                                                            </div>

                                                                            <p className="text-sm ">
                                                                                {aiAgentName &&
                                                                                    `${aiAgentName} - `}
                                                                                {agentDetails?.type ===
                                                                                "InventoryManagement"
                                                                                    ? "Inventory Report"
                                                                                    : getAgentName(
                                                                                          agentDetails?.type
                                                                                      ) || ""}
                                                                            </p>
                                                                        </div>
                                                                    ) : step?.key ===
                                                                          "source-action-tigger" &&
                                                                      agentDetails?.type ===
                                                                          "EDIAssistant" &&
                                                                      selectedMarketingConnection?.length >
                                                                          0 ? (
                                                                        <p className="text-sm ">
                                                                            SPS Commerce
                                                                        </p>
                                                                    ) : step?.key ===
                                                                          "source-action-tigger" &&
                                                                      step?.configured &&
                                                                      sourceActionTrigger !==
                                                                          "email" &&
                                                                      agentDetails?.type !==
                                                                          "EDIAssistant" &&
                                                                      sourceActionTrigger ? (
                                                                        sourceActionTrigger ===
                                                                        "auto_generate_email" ? (
                                                                            <div className="flex items-center gap-2 text-[#16A34A] bg-[#DCFCE7] px-2.5 py-1.5 rounded-md border border-[#16A34A]">
                                                                                <i className="ri-user-3-line text-[#16A34A] text-xs"></i>

                                                                                <p className="text-sm ">
                                                                                    {dummyEmail}
                                                                                </p>
                                                                            </div>
                                                                        ) : (
                                                                            <div className="flex items-center gap-2  ">
                                                                                <img
                                                                                    src={
                                                                                        getSourceActionTrigger(
                                                                                            sourceActionTrigger
                                                                                        )?.icon
                                                                                    }
                                                                                    alt="icon"
                                                                                    className="w-4 h-4"
                                                                                />
                                                                                <p className="text-sm text-[#64748B]">
                                                                                    {
                                                                                        getSourceActionTrigger(
                                                                                            sourceActionTrigger
                                                                                        )?.name
                                                                                    }
                                                                                </p>
                                                                            </div>
                                                                        )
                                                                    ) : (
                                                                        <div className="flex items-center gap-2">
                                                                            {step?.approverName &&
                                                                                step?.approvalPossible && (
                                                                                    <Button
                                                                                        btnText={
                                                                                            step?.approverName
                                                                                        }
                                                                                        btnClassname="!py-1 !px-2 !bg-slate-100 !border !border-slate-200 !text-slate-500  !text-xs !w-fit !cursor-default"
                                                                                        icon={
                                                                                            <i
                                                                                                className={`${
                                                                                                    step?.approverName
                                                                                                        ? "ri-user-3-line text-slate-500 text-sm"
                                                                                                        : "ri-link text-slate-500 text-sm"
                                                                                                }`}
                                                                                            ></i>
                                                                                        }
                                                                                    />
                                                                                )}

                                                                            {agentDetails?.type ===
                                                                                "InventoryManagement" &&
                                                                                step?.key ===
                                                                                    "update_inventory" &&
                                                                                selectedAction && (
                                                                                    <Button
                                                                                        btnText={
                                                                                            camelCaseToRegularCase(
                                                                                                selectedAction
                                                                                            ) ===
                                                                                            "Notify User"
                                                                                                ? "Notify me"
                                                                                                : camelCaseToRegularCase(
                                                                                                      selectedAction
                                                                                                  )
                                                                                        }
                                                                                        btnClassname="!py-1 !px-2 !bg-slate-100 !border !border-slate-200 !text-slate-500  !text-xs !w-fit !cursor-default"
                                                                                        icon={
                                                                                            <i
                                                                                                className={
                                                                                                    "ri-link text-slate-500 text-sm"
                                                                                                }
                                                                                            ></i>
                                                                                        }
                                                                                    />
                                                                                )}
                                                                        </div>
                                                                    )}

                                                                    {step?.key !==
                                                                        "order_extraction" && (
                                                                        <Button
                                                                            btnText="Edit step"
                                                                            btnClassname="!p-0 !bg-transparent !text-slate-500 !text-xs !w-fit"
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                setCurrentStep(
                                                                                    step?.key
                                                                                );
                                                                            }}
                                                                            icon={
                                                                                <i className=" ri-edit-2-line text-slate-400 text-sm"></i>
                                                                            }
                                                                            disabled={
                                                                                !step?.isActive &&
                                                                                step?.isEnabled
                                                                            }
                                                                        />
                                                                    )}
                                                                </div>
                                                                {step?.overviewText && (
                                                                    <p className="text-sm text-slate-500 mt-1">
                                                                        {step?.overviewText}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>

                                                        {agentSteps?.length - 1 !== idx && (
                                                            <img
                                                                src="https://res.cloudinary.com/dvxi7qcmd/image/upload/v1737392368/arrow_down_cmoqw7.svg"
                                                                alt="arrow down"
                                                                height={36}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                    </div>
                </>
            ) : (
                <Preview
                    openPreview={openPreview}
                    setOpenPreview={setOpenPreview}
                    agentType={getAgentName(agentDetails?.type)}
                    agentName={aiAgentName}
                    rawAgentType={agentDetails?.type}
                    steps={agentDetails?.steps}
                    trigger={sourceActionTrigger}
                    agentIsActive={agentIsActive}
                />
            )}

            {agentDetails?.type === "marketingCampaign" && (
                <MarketingCampaign
                    setCurrentStep={setCurrentStep}
                    currentStep={currentStep}
                    handleStepConfiguration={handleStepConfiguration}
                    aiAgentName={aiAgentName}
                    setAiAgentName={setAiAgentName}
                    sourceActionTrigger={sourceActionTrigger}
                    setSourceActionTrigger={setSourceActionTrigger}
                    fetchedAllChannelsSuccess={fetchedAllChannelsSuccess}
                    agentDetails={agentDetails}
                    agentSteps={agentSteps}
                    agentId={agentId}
                    aiTeammateId={aiTeammateId}
                    avatar={avatar}
                />
            )}

            {agentDetails?.type === "EDIAssistant" && (
                <EDIAssistant
                    setCurrentStep={setCurrentStep}
                    currentStep={currentStep}
                    handleStepConfiguration={handleStepConfiguration}
                    fetchedAllChannelsSuccess={fetchedAllChannelsSuccess}
                    selectedMarketingConnection={selectedMarketingConnection}
                    setSelectedMarketingConnection={setSelectedMarketingConnection}
                    aiAgentName={aiAgentName}
                    setAiAgentName={setAiAgentName}
                    agentDetails={agentDetails}
                    agentSteps={agentSteps}
                    agentId={agentId}
                    aiTeammateId={aiTeammateId}
                    avatar={avatar}
                />
            )}
            {agentDetails?.type === "InventoryManagement" && (
                <InventoryManagement
                    setCurrentStep={setCurrentStep}
                    currentStep={currentStep}
                    agentSteps={agentSteps}
                    currentStepIndex={currentStepIndex}
                    handleAgentStepChange={handleAgentStepChange}
                    handleApproverChange={handleApproverChange}
                    setAddTeamMemberModal={setAddTeamMemberModal}
                    setDebouncedSearchTeamMember={setDebouncedSearchTeamMember}
                    fetchingTeamMember={fetchingTeamMember}
                    teamMembers={teamMembers}
                    selectedAction={selectedAction}
                    setSelectedAction={setSelectedAction}
                />
            )}

            {/* Name your AI Agent */}

            <AgentSideDrawer
                open={currentStep === "name-agent"}
                closeModal={() => {
                    setCurrentStep("");
                }}
                modalRef={modalRef}
            >
                <div className=" flex  !bg-white flex-col  font-rocGroteskMedium  ">
                    <div className="relative">
                        {" "}
                        <div className="px-6 flex justify-between py-6 items-center">
                            <p className="text-sm font-rocGroteskMedium text-slate-800">
                                Name your AI Agent
                            </p>
                            <i
                                className="ri-close-fill text-xl text-slate-500 cursor-pointer border border-slate-200 rounded py-0 px-1"
                                onClick={() => {
                                    setCurrentStep("");
                                }}
                            ></i>
                        </div>
                        <div className="px-6">
                            <div className="relative w-fit mb-[30px] shadow-[0px_20px_24px_-4px_#10182814]">
                                {uploadingAvatar ? (
                                    <div className="w-14 h-14 rounded-[10px] border flex justify-center items-center">
                                        <Loader size={6} />
                                    </div>
                                ) : (
                                    <img
                                        src={avatar || aiAvatarArr[0]}
                                        alt={`avatar`}
                                        className={`w-14 h-14`}
                                    />
                                )}

                                <div
                                    onClick={() => setOpenAvatarModal(true)}
                                    className={`w-6 h-6 rounded-full  border-[3px] border-white flex justify-center items-center absolute bottom-[-9px] right-[-12px] cursor-pointer ${
                                        agentDetails?.type === "orderProcessing"
                                            ? "bg-p-50"
                                            : agentDetails?.type === "EDIAssistant"
                                            ? "bg-[#00C6FA]"
                                            : agentDetails?.type === "InventoryManagement"
                                            ? "bg-[#B9017A]"
                                            : "bg-[#EA580C]"
                                    }`}
                                >
                                    <i className="ri-pencil-fill text-white text-[14px]"></i>
                                </div>

                                {openAvatarModal && (
                                    <div
                                        ref={avatarModalRef}
                                        className="w-[464px] h-[180px] bg-white rounded-lg absolute right-[-465px] top-[52px] border border-slate-100 shadow-[0px_20px_24px_-4px_#10182814;]"
                                    >
                                        <div className="px-4 py-2.5 flex items-center justify-between border-b border-slate-200">
                                            <span className="text-sm font-rocGroteskMedium">
                                                Change agent avatar
                                            </span>
                                            <i
                                                onClick={() => setOpenAvatarModal(false)}
                                                className="ri-close-fill text-2xl cursor-pointer"
                                            ></i>
                                        </div>
                                        <div className="px-4 py-3 grid grid-cols-11 gap-2">
                                            {aiAvatarArr?.map((avatarUrl, idx) => {
                                                return (
                                                    <div
                                                        key={idx}
                                                        onClick={() => {
                                                            setAvatar(avatarUrl);
                                                        }}
                                                    >
                                                        <img
                                                            src={avatarUrl}
                                                            alt={`avatar_${idx}`}
                                                            className={`w-8 h-8 cursor-pointer hover:border-[1.5px] rounded-[10px] border-black ${
                                                                avatar === avatarUrl &&
                                                                " border-[1.5px] "
                                                            }`}
                                                        />
                                                    </div>
                                                );
                                            })}
                                            <div className="relative">
                                                <div
                                                    onClick={() => {
                                                        const elem =
                                                            document.getElementById(
                                                                "uploadAiAvatar"
                                                            );
                                                        elem.click();
                                                    }}
                                                    className="w-8 h-8 border border-slate-300 rounded-lg bg-slate-200 flex justify-center items-center cursor-pointer"
                                                >
                                                    <i className="ri-image-add-fill text-[18px]"></i>
                                                </div>
                                                <input
                                                    id="uploadAiAvatar"
                                                    type="file"
                                                    accept="image/*"
                                                    className="absolute top-0 w-8 h-8 hidden"
                                                    onChange={(evt) => {
                                                        handleUploadAvatar(
                                                            evt.target.files[0].name,
                                                            evt.target.files[0]
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="mb-6">
                                <div className="flex items-center w-full justify-between mb-4">
                                    <p className="text-sm font-rocGroteskMedium">
                                        Name your AI teammate <span className="text-r-50">*</span>
                                    </p>
                                </div>
                                <div className="border-b-[1px] border-b-[#E2E8F0] pb-5">
                                    <input
                                        type="text"
                                        placeholder="Enter your AI teammate name"
                                        className="!text-2xl font-rocGroteskMedium  placeholder:text-[#CBD5E1] !border-none outline-none w-full placeholder:pl-1 caret-slate-700 !leading-6"
                                        name="aiName"
                                        value={aiAgentName}
                                        onChange={(e) => {
                                            setAiAgentName(e?.target?.value);
                                            handleStepConfiguration(e.target.value ? true : false);
                                        }}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="flex space-x-2 mb-8 overflow-x-auto">
                                {AiNameSuggestions?.map((aiName, idx) => (
                                    <span
                                        key={aiName + String(idx)}
                                        className="text-sm font-rocGroteskMedium px-2 py-[2px] h-6 bg-slate-100 rounded cursor-pointer"
                                        onClick={() => {
                                            setAiAgentName(aiName);
                                            handleStepConfiguration(true);
                                        }}
                                    >
                                        {aiName}
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </AgentSideDrawer>

            {/* Select the source - action trigger */}
            {(agentDetails?.type === "orderProcessing" ||
                agentDetails?.type === "InventoryManagement") && (
                <AgentSideDrawer open={currentStep === "source-action-tigger"} modalRef={modalRef}>
                    <div className=" flex  !bg-white flex-col  font-rocGroteskMedium  ">
                        <div className="relative">
                            {" "}
                            <div className="px-6 flex justify-between py-6 items-center">
                                <p className="text-sm font-rocGroteskMedium text-slate-800">
                                    Select the source - action trigger
                                </p>
                                <i
                                    className="ri-close-fill text-xl text-slate-500 cursor-pointer border border-slate-200 rounded py-0 px-1"
                                    onClick={() => {
                                        setCurrentStep("");
                                    }}
                                ></i>
                            </div>
                            <div className="mx-6 border border-slate-200 p-4 rounded-lg">
                                <div className="space-y-2 border-b border-slate-100 pb-4">
                                    <div className="flex justify-between mb-1">
                                        <div className="flex items-center space-x-3">
                                            <Checkbox
                                                name="email"
                                                isChecked={sourceActionTrigger === "email"}
                                                required={!sourceActionTrigger}
                                                onChange={(evt) => {
                                                    setSourceActionTrigger("email");
                                                    handleStepConfiguration(true);
                                                }}
                                                className={
                                                    "!h-4 !w-4 !rounded-[4px] checked:!bg-y-10 "
                                                }
                                            />
                                            <span
                                                className={`text-sm font-rocGroteskMedium ${
                                                    sourceActionTrigger === "email"
                                                        ? "text-gm-50"
                                                        : "text-slate-500"
                                                }`}
                                            >
                                                Email
                                            </span>
                                        </div>

                                        {sourceActionTrigger === "email" && (
                                            <Button
                                                btnText="Connect your email account"
                                                btnClassname="!p-2.5 !bg-slate-50 !text-b-55 !text-xs !w-fit"
                                                icon={
                                                    <i className="ri-add-line text-b-55 text-sm"></i>
                                                }
                                                onClick={() => {
                                                    setEmailClientModal(true);
                                                    handleStepConfiguration(true);
                                                }}
                                            />
                                        )}
                                    </div>

                                    <div className="flex items-center space-x-3">
                                        <Checkbox
                                            name="auto_email"
                                            isChecked={
                                                sourceActionTrigger === "auto_generate_email"
                                            }
                                            required={!sourceActionTrigger}
                                            onChange={(evt) => {
                                                setSourceActionTrigger("auto_generate_email");
                                                handleStepConfiguration(true);
                                            }}
                                            className={"!h-4 !w-4 !rounded-[4px] checked:!bg-y-10 "}
                                        />
                                        <span
                                            className={`text-sm font-rocGroteskMedium ${
                                                sourceActionTrigger === "auto_generate_email"
                                                    ? "text-gm-50"
                                                    : "text-slate-500"
                                            }`}
                                        >
                                            Let Synth automatically generate an email address for
                                            this AI teammate
                                        </span>
                                    </div>
                                    {sourceActionTrigger === "auto_generate_email" && (
                                        <div className="text-xs text-slate-500 font-rocGroteskMedium bg-slate-100 rounded px-1.5 py-1 mt-2 w-fit">
                                            <span>Email:</span> <span>{dummyEmail}</span>
                                        </div>
                                    )}
                                </div>

                                <div className="mt-4">
                                    <p className="text-sm text-slate-500 p-3 bg-slate-100 border border-slate-200 rounded">
                                        This gives the AI teammate the ability to detect when there
                                        is a potential order.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </AgentSideDrawer>
            )}

            {(agentDetails?.type === "orderProcessing" ||
                agentDetails?.type === "EDIAssistant") && (
                <>
                    {/* Identify if a message contains a sales order, order_check */}
                    <AgentSideDrawer open={currentStep === "order_check"} modalRef={modalRef}>
                        <div className=" flex  !bg-white flex-col  font-rocGroteskMedium  ">
                            <div className="relative">
                                {" "}
                                <div className="px-6 py-6">
                                    <div className="flex justify-between  items-center">
                                        <p className="text-sm font-rocGroteskMedium text-slate-800">
                                            AI Teammate's customization
                                        </p>
                                        <i
                                            className="ri-close-fill text-xl text-slate-500 cursor-pointer border border-slate-200 rounded py-0 px-1"
                                            onClick={() => {
                                                setCurrentStep("");
                                            }}
                                        ></i>
                                    </div>
                                    <p className="text-sm text-slate-500 ">
                                        Set how you want this AI team-mate to work
                                    </p>
                                </div>
                                <div className="mx-6 border border-slate-200 p-4 rounded-lg">
                                    <div className="space-y-3">
                                        <div className="flex justify-between">
                                            <div className="flex gap-0.5 items-center">
                                                <p className="text-sm text-slate-800">
                                                    Identify if a message contains a sales order
                                                </p>
                                                <SynthTooltip
                                                    divId={`identify-order`}
                                                    position={"top"}
                                                    icon={
                                                        <i className="ri-information-fill text-slate-300 text-sm"></i>
                                                    }
                                                    contentIcon={<></>}
                                                    title=""
                                                    content={
                                                        agentSteps[currentStepIndex]?.description
                                                    }
                                                    styling={{
                                                        width: "270px",
                                                        background: "#142837",
                                                        borderRadius: "6px",
                                                    }}
                                                    contentClass="text-xs"
                                                />
                                            </div>

                                            {agentSteps[currentStepIndex]?.showApproval && (
                                                <div className="flex items-center gap-1">
                                                    <p className="text-gm-45 text-xs">
                                                        Turn{" "}
                                                        {agentSteps[currentStepIndex]
                                                            ?.approvalPossible
                                                            ? "off"
                                                            : "on"}{" "}
                                                        need for approval
                                                    </p>

                                                    <ToggleInput
                                                        checked={
                                                            agentSteps[currentStepIndex]
                                                                ?.approvalPossible as boolean
                                                        }
                                                        name={"approvalPossible"}
                                                        onChange={(e) => {
                                                            handleAgentStepChange(
                                                                currentStepIndex,
                                                                "approvalPossible",
                                                                e.target.checked ? true : false
                                                            );
                                                        }}
                                                        className="w-slider before:!h-4 before:!w-4 h-5 w-[30px] before:left-[2px] rounded-[30px]"
                                                    />
                                                </div>
                                            )}
                                        </div>
                                        <div className="flex items-center gap-2">
                                            <p className="bg-slate-200 flex-1 h-[1px] w-full"></p>
                                            <p className="text-slate-500 text-sm">
                                                Select approver
                                            </p>
                                            <p className="bg-slate-200 flex-1 h-[1px] w-full"></p>
                                        </div>

                                        {agentSteps[currentStepIndex]?.approvalPossible && (
                                            <SelectInput
                                                value={
                                                    agentSteps[currentStepIndex]?.approverName ||
                                                    (agentSteps[currentStepIndex]
                                                        ?.approvalIdString as string) ||
                                                    ""
                                                }
                                                name="approvalIdString"
                                                nameFirst={true}
                                                placeholder={"Select approver"}
                                                handleChange={(name, value) => {
                                                    handleApproverChange(value);
                                                }}
                                                handleInputChange={debounce((evt) => {
                                                    setDebouncedSearchTeamMember(evt.target.value);
                                                }, 800)}
                                                isRequired={
                                                    agentSteps[currentStepIndex]?.approvalPossible
                                                }
                                                searchLoading={fetchingTeamMember}
                                                dropdownOptions={teamMembers?.map((member) => ({
                                                    label: member?.fullName
                                                        ? member?.fullName
                                                        : member?.email,
                                                    value: member?._id,
                                                }))}
                                                dropdownClassName="!pb-0 !max-h-[320px]"
                                                rightDropdownContainerClassName="!sticky bottom-0"
                                                customRightDropdownContainer={
                                                    <div className="py-1 px-1  flex items-center  bg-white !h-[48px] sticky w-full bottom-0 border-t border-slate-200">
                                                        <div
                                                            className="flex items-center w-fit cursor-pointer gap-2"
                                                            onClick={() => {
                                                                setAddTeamMemberModal(true);
                                                            }}
                                                        >
                                                            <i className="ri-add-fill text-[#D39901] text-[10px] rounded-full py-0.5 px-1 bg-[#FFF5DA]"></i>

                                                            <span className="text-[12px] font-rocGroteskMedium text-[#D39901] underline">
                                                                Add a new team-mate
                                                            </span>
                                                        </div>
                                                    </div>
                                                }
                                            />
                                        )}

                                        <TextareaInput
                                            name={"customInstructions"}
                                            value={
                                                (agentSteps[currentStepIndex]
                                                    ?.customInstructions as string) || ""
                                            }
                                            onChange={(e) => {
                                                handleAgentStepChange(
                                                    currentStepIndex,
                                                    "customInstructions",
                                                    e.target.value
                                                );
                                            }}
                                            rows={3}
                                            placeholder={"Enter custom instructions"}
                                            inputPlaceholder="Provide any specific instructions you'd like the AI Agent to follow. "
                                            required={false}
                                        />
                                    </div>

                                    <div className="mt-4">
                                        <p className="text-sm text-slate-500 p-3 bg-slate-100 border border-slate-200 rounded">
                                            Custom instructions let you tailor how your AI Agent
                                            behaves in specific steps of a workflow. Use them to
                                            guide the Agent's tone, priorities, or handling of
                                            unique business rules. This helps ensure your AI Agent
                                            aligns with your brand's voice and operational
                                            standards.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </AgentSideDrawer>
                    {/* Extract order details, order_assistant */}
                    <AgentSideDrawer open={currentStep === "order_assistant"} modalRef={modalRef}>
                        <div className=" flex  !bg-white flex-col  font-rocGroteskMedium  ">
                            <div className="relative ">
                                {" "}
                                <div className="px-6 py-6">
                                    <div className="flex justify-between  items-center">
                                        <p className="text-sm font-rocGroteskMedium text-slate-800">
                                            AI Teammate's customization
                                        </p>
                                        <i
                                            className="ri-close-fill text-xl text-slate-500 cursor-pointer border border-slate-200 rounded py-0 px-1"
                                            onClick={() => {
                                                setCurrentStep("");
                                            }}
                                        ></i>
                                    </div>
                                    <p className="text-sm text-slate-500 ">
                                        Set how you want this AI team-mate to work
                                    </p>
                                </div>
                                <div className="mx-6 border border-slate-200 p-4 rounded-lg">
                                    <div className="space-y-4">
                                        <div className="flex justify-between">
                                            <div className="flex gap-0.5 items-center">
                                                <p className="text-sm text-slate-800">
                                                    Extract order details
                                                </p>
                                                <SynthTooltip
                                                    divId={`extract-order-details`}
                                                    position={"top"}
                                                    icon={
                                                        <i className="ri-information-fill text-slate-300 text-sm"></i>
                                                    }
                                                    contentIcon={<></>}
                                                    title=""
                                                    content={
                                                        agentSteps[currentStepIndex]?.description
                                                    }
                                                    styling={{
                                                        width: "270px",
                                                        background: "#142837",
                                                        borderRadius: "6px",
                                                    }}
                                                    contentClass="text-xs"
                                                />
                                            </div>

                                            {agentSteps[currentStepIndex]?.showApproval && (
                                                <div className="flex items-center gap-1">
                                                    <p className="text-gm-45 text-xs">
                                                        Turn on need for approval
                                                    </p>
                                                    <ToggleInput
                                                        checked={
                                                            agentSteps[currentStepIndex]
                                                                ?.approvalPossible as boolean
                                                        }
                                                        name={"approvalPossible"}
                                                        onChange={(e) => {
                                                            handleAgentStepChange(
                                                                currentStepIndex,
                                                                "approvalPossible",
                                                                e.target.checked ? true : false
                                                            );
                                                        }}
                                                        className="w-slider before:!h-4 before:!w-4 h-5 w-[30px] before:left-[2px] rounded-[30px]"
                                                    />
                                                </div>
                                            )}
                                        </div>

                                        {agentSteps[currentStepIndex]?.approvalPossible && (
                                            <SelectInput
                                                value={
                                                    agentSteps[currentStepIndex]?.approverName ||
                                                    (agentSteps[currentStepIndex]
                                                        ?.approvalIdString as string) ||
                                                    ""
                                                }
                                                name="approvalIdString"
                                                nameFirst={true}
                                                placeholder={"Select approver"}
                                                handleChange={(name, value) => {
                                                    handleApproverChange(value);
                                                }}
                                                handleInputChange={debounce((evt) => {
                                                    setDebouncedSearchTeamMember(evt.target.value);
                                                }, 800)}
                                                isRequired={
                                                    agentSteps[currentStepIndex]?.approvalPossible
                                                }
                                                searchLoading={fetchingTeamMember}
                                                dropdownOptions={teamMembers?.map((member) => ({
                                                    label: member?.fullName
                                                        ? member?.fullName
                                                        : member?.email,
                                                    value: member?._id,
                                                }))}
                                                dropdownClassName="!pb-0 !max-h-[320px]"
                                                rightDropdownContainerClassName="!sticky bottom-0"
                                                customRightDropdownContainer={
                                                    <div className="py-1 px-1  flex items-center  bg-white !h-[48px] sticky w-full bottom-0 border-t border-slate-200">
                                                        <div
                                                            className="flex items-center w-fit cursor-pointer gap-2"
                                                            onClick={() => {
                                                                setAddTeamMemberModal(true);
                                                            }}
                                                        >
                                                            <i className="ri-add-fill text-[#D39901] text-[10px] rounded-full py-0.5 px-1 bg-[#FFF5DA]"></i>

                                                            <span className="text-[12px] font-rocGroteskMedium text-[#D39901] underline">
                                                                Add a new team-mate
                                                            </span>
                                                        </div>
                                                    </div>
                                                }
                                            />
                                        )}

                                        <TextareaInput
                                            name={"customInstructions"}
                                            value={
                                                (agentSteps[currentStepIndex]
                                                    ?.customInstructions as string) || ""
                                            }
                                            onChange={(e) => {
                                                handleAgentStepChange(
                                                    currentStepIndex,
                                                    "customInstructions",
                                                    e.target.value
                                                );
                                            }}
                                            rows={3}
                                            placeholder={"Enter custom instructions"}
                                            inputPlaceholder="Provide any specific instructions you'd like the AI Agent to follow. "
                                            required={false}
                                        />
                                    </div>

                                    <div className="mt-4">
                                        <p className="text-sm text-slate-500 p-3 bg-slate-100 border border-slate-200 rounded">
                                            Custom instructions let you tailor how your AI Agent
                                            behaves in specific steps of a workflow. Use them to
                                            guide the Agent's tone, priorities, or handling of
                                            unique business rules. This helps ensure your AI Agent
                                            aligns with your brand's voice and operational
                                            standards.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </AgentSideDrawer>
                    {/* Monitor inventory levels, inventory_check */}
                    <AgentSideDrawer open={currentStep === "inventory_check"} modalRef={modalRef}>
                        <div className=" flex  !bg-white flex-col  font-rocGroteskMedium  ">
                            <div className="relative overflow-y-scroll">
                                {" "}
                                <div className="px-6 py-6">
                                    <div className="flex justify-between  items-center">
                                        <p className="text-sm font-rocGroteskMedium text-slate-800">
                                            AI Teammate's customization
                                        </p>
                                        <i
                                            className="ri-close-fill text-xl text-slate-500 cursor-pointer border border-slate-200 rounded py-0 px-1"
                                            onClick={() => {
                                                setCurrentStep("");
                                            }}
                                        ></i>
                                    </div>
                                    <p className="text-sm text-slate-500 ">
                                        Set how you want this AI team-mate to work
                                    </p>
                                </div>
                                <div className="mx-6 border border-slate-200 p-4 rounded-lg">
                                    <div className="space-y-3">
                                        <div className="flex justify-between">
                                            <div className="flex gap-0.5 items-center">
                                                <p className="text-sm text-slate-800">
                                                    Monitor inventory levels
                                                </p>
                                                <SynthTooltip
                                                    divId={`monitor-inventory-levels`}
                                                    position={"top"}
                                                    icon={
                                                        <i className="ri-information-fill text-slate-300 text-sm"></i>
                                                    }
                                                    contentIcon={<></>}
                                                    title=""
                                                    content={
                                                        agentSteps[currentStepIndex]?.description
                                                    }
                                                    styling={{
                                                        width: "270px",
                                                        background: "#142837",
                                                        borderRadius: "6px",
                                                    }}
                                                    contentClass="text-xs"
                                                />
                                            </div>

                                            {agentSteps[currentStepIndex]?.showApproval && (
                                                <div className="flex items-center gap-1">
                                                    <p className="text-gm-45 text-xs">
                                                        Turn{" "}
                                                        {agentSteps[currentStepIndex]
                                                            ?.approvalPossible
                                                            ? "off"
                                                            : "on"}{" "}
                                                        need for approval
                                                    </p>
                                                    <ToggleInput
                                                        checked={
                                                            agentSteps[currentStepIndex]
                                                                ?.approvalPossible as boolean
                                                        }
                                                        name={"approvalPossible"}
                                                        onChange={(e) => {
                                                            handleAgentStepChange(
                                                                currentStepIndex,
                                                                "approvalPossible",
                                                                e.target.checked ? true : false
                                                            );
                                                        }}
                                                        className="w-slider before:!h-4 before:!w-4 h-5 w-[30px] before:left-[2px] rounded-[30px]"
                                                    />
                                                </div>
                                            )}
                                        </div>
                                        <div className="flex items-center gap-2">
                                            <p className="bg-slate-200 flex-1 h-[1px] w-full"></p>
                                            <p className="text-slate-500 text-sm">
                                                Select control action for if product is out of stock
                                            </p>
                                            <p className="bg-slate-200 flex-1 h-[1px] w-full"></p>
                                        </div>

                                        {agentSteps[currentStepIndex]?.approvalPossible && (
                                            <SelectInput
                                                value={
                                                    agentSteps[currentStepIndex]?.approverName ||
                                                    (agentSteps[currentStepIndex]
                                                        ?.approvalIdString as string) ||
                                                    ""
                                                }
                                                name="approvalIdString"
                                                nameFirst={true}
                                                placeholder={"Select approver"}
                                                handleChange={(name, value) => {
                                                    handleApproverChange(value);
                                                }}
                                                handleInputChange={debounce((evt) => {
                                                    setDebouncedSearchTeamMember(evt.target.value);
                                                }, 800)}
                                                isRequired={
                                                    agentSteps[currentStepIndex]?.approvalPossible
                                                }
                                                searchLoading={fetchingTeamMember}
                                                dropdownOptions={teamMembers?.map((member) => ({
                                                    label: member?.fullName
                                                        ? member?.fullName
                                                        : member?.email,
                                                    value: member?._id,
                                                }))}
                                                dropdownClassName="!pb-0 !max-h-[320px]"
                                                rightDropdownContainerClassName="!sticky bottom-0"
                                                customRightDropdownContainer={
                                                    <div className="py-1 px-1  flex items-center  bg-white !h-[48px] sticky w-full bottom-0 border-t border-slate-200">
                                                        <div
                                                            className="flex items-center w-fit cursor-pointer gap-2"
                                                            onClick={() => {
                                                                setAddTeamMemberModal(true);
                                                            }}
                                                        >
                                                            <i className="ri-add-fill text-[#D39901] text-[10px] rounded-full py-0.5 px-1 bg-[#FFF5DA]"></i>

                                                            <span className="text-[12px] font-rocGroteskMedium text-[#D39901] underline">
                                                                Add a new team-mate
                                                            </span>
                                                        </div>
                                                    </div>
                                                }
                                            />
                                        )}

                                        <SelectInput
                                            value={
                                                selectedAction ||
                                                (agentSteps[currentStepIndex]
                                                    ?.selectedAction as string) ||
                                                ""
                                            }
                                            name="selectedAction"
                                            placeholder={"Select control action"}
                                            handleChange={(name, value) => {
                                                setSelectedAction(value);
                                                // handleAgentStepChange(currentStepIndex, name, value);
                                            }}
                                            isRequired={true}
                                            dropdownOptions={agentSteps[
                                                currentStepIndex
                                            ]?.actions?.map((action) => ({
                                                label:
                                                    camelCaseToRegularCase(action?.name) ===
                                                    "Notify User"
                                                        ? "Notify me"
                                                        : camelCaseToRegularCase(action?.name),
                                                value: action?.name,
                                            }))}
                                        />

                                        <TextareaInput
                                            name={"customInstructions"}
                                            value={
                                                (agentSteps[currentStepIndex]
                                                    ?.customInstructions as string) || ""
                                            }
                                            onChange={(e) => {
                                                handleAgentStepChange(
                                                    currentStepIndex,
                                                    "customInstructions",
                                                    e.target.value
                                                );
                                            }}
                                            rows={3}
                                            placeholder={"Enter custom instructions"}
                                            inputPlaceholder="Provide any specific instructions you'd like the AI Agent to follow. "
                                            required={false}
                                        />
                                    </div>

                                    <div className="mt-4">
                                        <p className="text-sm text-slate-500 p-3 bg-slate-100 border border-slate-200 rounded">
                                            Custom instructions let you tailor how your AI Agent
                                            behaves in specific steps of a workflow. Use them to
                                            guide the Agent's tone, priorities, or handling of
                                            unique business rules. This helps ensure your AI Agent
                                            aligns with your brand's voice and operational
                                            standards.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </AgentSideDrawer>
                    {/* Generate sales orders, order_create */}
                    <AgentSideDrawer open={currentStep === "order_create"} modalRef={modalRef}>
                        <div className=" flex  !bg-white flex-col  font-rocGroteskMedium  ">
                            <div className="relative">
                                <div className="px-6 py-6 !sticky !top-0 bg-white !z-10 ">
                                    <div className="flex justify-between  items-center">
                                        <p className="text-sm font-rocGroteskMedium text-slate-800">
                                            AI Teammate's customization
                                        </p>
                                        <i
                                            className="ri-close-fill text-xl text-slate-500 cursor-pointer border border-slate-200 rounded py-0 px-1"
                                            onClick={() => {
                                                setCurrentStep("");
                                            }}
                                        ></i>
                                    </div>
                                    <p className="text-sm text-slate-500 ">
                                        Set how you want this AI team-mate to work
                                    </p>
                                </div>
                                <div className="mx-6 border border-slate-200 p-4 rounded-lg">
                                    <div className="space-y-3">
                                        <div className="flex justify-between">
                                            <div className="flex gap-0.5 items-center">
                                                <p className="text-sm text-slate-800">
                                                    Generate sales orders
                                                </p>
                                                <SynthTooltip
                                                    divId={agentSteps[currentStepIndex]?.key}
                                                    position={"top"}
                                                    icon={
                                                        <i className="ri-information-fill text-slate-300 text-sm"></i>
                                                    }
                                                    contentIcon={<></>}
                                                    title=""
                                                    content={
                                                        agentSteps[currentStepIndex]?.description
                                                    }
                                                    styling={{
                                                        width: "270px",
                                                        background: "#142837",
                                                        borderRadius: "6px",
                                                    }}
                                                    contentClass="text-xs"
                                                />
                                            </div>

                                            {agentSteps[currentStepIndex]?.showApproval && (
                                                <div className="flex items-center gap-1">
                                                    <p className="text-gm-45 text-xs">
                                                        <p className="text-gm-45 text-xs">
                                                            Turn{" "}
                                                            {agentSteps[currentStepIndex]
                                                                ?.approvalPossible
                                                                ? "off"
                                                                : "on"}{" "}
                                                            need for approval
                                                        </p>
                                                    </p>
                                                    <ToggleInput
                                                        checked={
                                                            agentSteps[currentStepIndex]
                                                                ?.approvalPossible as boolean
                                                        }
                                                        name={"approvalPossible"}
                                                        onChange={(e) => {
                                                            handleAgentStepChange(
                                                                currentStepIndex,
                                                                "approvalPossible",
                                                                e.target.checked ? true : false
                                                            );
                                                        }}
                                                        className="w-slider before:!h-4 before:!w-4 h-5 w-[30px] before:left-[2px] rounded-[30px]"
                                                    />
                                                </div>
                                            )}
                                        </div>
                                        <div className="flex items-center gap-2">
                                            <p className="bg-slate-200 flex-1 h-[1px] w-full"></p>
                                            <p className="text-slate-500 text-sm">
                                                Select approver
                                            </p>
                                            <p className="bg-slate-200 flex-1 h-[1px] w-full"></p>
                                        </div>

                                        {agentSteps[currentStepIndex]?.approvalPossible && (
                                            <SelectInput
                                                value={
                                                    agentSteps[currentStepIndex]?.approverName ||
                                                    (agentSteps[currentStepIndex]
                                                        ?.approvalIdString as string) ||
                                                    ""
                                                }
                                                name="approvalIdString"
                                                nameFirst={true}
                                                placeholder={"Select approver"}
                                                handleChange={(name, value) => {
                                                    handleApproverChange(value);
                                                }}
                                                handleInputChange={debounce((evt) => {
                                                    setDebouncedSearchTeamMember(evt.target.value);
                                                }, 800)}
                                                isRequired={
                                                    agentSteps[currentStepIndex]?.approvalPossible
                                                }
                                                searchLoading={fetchingTeamMember}
                                                dropdownOptions={teamMembers?.map((member) => ({
                                                    label: member?.fullName
                                                        ? member?.fullName
                                                        : member?.email,
                                                    value: member?._id,
                                                }))}
                                                dropdownClassName="!pb-0 !max-h-[320px]"
                                                rightDropdownContainerClassName="!sticky bottom-0"
                                                customRightDropdownContainer={
                                                    <div className="py-1 px-1  flex items-center  bg-white !h-[48px] sticky w-full bottom-0 border-t border-slate-200">
                                                        <div
                                                            className="flex items-center w-fit cursor-pointer gap-2"
                                                            onClick={() => {
                                                                setAddTeamMemberModal(true);
                                                            }}
                                                        >
                                                            <i className="ri-add-fill text-[#D39901] text-[10px] rounded-full py-0.5 px-1 bg-[#FFF5DA]"></i>

                                                            <span className="text-[12px] font-rocGroteskMedium text-[#D39901] underline">
                                                                Add a new team-mate
                                                            </span>
                                                        </div>
                                                    </div>
                                                }
                                            />
                                        )}

                                        <TextareaInput
                                            name={"customInstructions"}
                                            value={
                                                (agentSteps[currentStepIndex]
                                                    ?.customInstructions as string) || ""
                                            }
                                            onChange={(e) => {
                                                handleAgentStepChange(
                                                    currentStepIndex,
                                                    "customInstructions",
                                                    e.target.value
                                                );
                                            }}
                                            rows={3}
                                            placeholder={"Enter custom instructions"}
                                            inputPlaceholder="Provide any specific instructions you'd like the AI Agent to follow. "
                                            required={false}
                                        />
                                    </div>

                                    <div className="mt-4">
                                        <p className="text-sm text-slate-500 p-3 bg-slate-100 border border-slate-200 rounded">
                                            Custom instructions let you tailor how your AI Agent
                                            behaves in specific steps of a workflow. Use them to
                                            guide the Agent's tone, priorities, or handling of
                                            unique business rules. This helps ensure your AI Agent
                                            aligns with your brand's voice and operational
                                            standards.
                                        </p>
                                    </div>
                                </div>
                                {agentSteps[currentStepIndex]?.actions?.length > 0 && (
                                    <div className="mb-10">
                                        <div className="flex justify-between my-6 mx-6">
                                            <div className="flex gap-1 items-center">
                                                <p className="text-sm text-[#0046A2]">
                                                    Next steps after order is created
                                                </p>
                                                <span className="text-xs text-slate-500">
                                                    (Optional)
                                                </span>
                                                <SynthTooltip
                                                    divId={"optional-next-steps"}
                                                    position={"top"}
                                                    icon={
                                                        <i className="ri-information-fill text-slate-300 text-sm"></i>
                                                    }
                                                    contentIcon={<></>}
                                                    title=""
                                                    content={
                                                        agentSteps[currentStepIndex]?.actions?.[0]
                                                            ?.description
                                                    }
                                                    styling={{
                                                        width: "220px",
                                                        background: "#142837",
                                                        borderRadius: "6px",
                                                    }}
                                                    contentClass="text-xs"
                                                />
                                            </div>
                                        </div>

                                        <div className="mx-6 border border-slate-200 p-4 rounded-lg">
                                            <div className="space-y-3">
                                                <div className="flex items-center gap-2">
                                                    <p className="bg-slate-200 flex-1 h-[1px] w-full"></p>
                                                    <p className="text-slate-500 text-sm">Action</p>
                                                    <p className="bg-slate-200 flex-1 h-[1px] w-full"></p>
                                                </div>
                                                {/* <TextInput
                                                    name={"action"}
                                                    type={"text"}
                                                    value={
                                                        "Transfer sales orders to an external system"
                                                    }
                                                    onChange={(e) => {}}
                                                    placeholder={"Action"}
                                                    disabled={true}

                                                /> */}
                                                <SelectInput
                                                    value={
                                                        createOrderAction
                                                            ? createOrderAction
                                                            : actionChanged
                                                            ? "No Action"
                                                            : ""
                                                    }
                                                    name="name"
                                                    placeholder={"Action"}
                                                    handleChange={(name, value) => {
                                                        setCreateOrderAction(value);
                                                        setActionChanged(true);
                                                    }}
                                                    dropdownOptions={createOrderActionStep}
                                                />

                                                {createOrderAction && (
                                                    <>
                                                        <SelectInput
                                                            value={
                                                                agentSteps[currentStepIndex]
                                                                    ?.actions?.[0]
                                                                    ?.externalSystem || ""
                                                            }
                                                            name="externalSystem"
                                                            placeholder={"External system"}
                                                            handleChange={(name, value) => {
                                                                handleActionChange(
                                                                    currentStepIndex,
                                                                    name,
                                                                    value
                                                                );
                                                            }}
                                                            handleInputChange={() => {}}
                                                            searchLoading={false}
                                                            dropdownOptions={[
                                                                {
                                                                    label: "Quickbooks",
                                                                    value: "quickbooks",
                                                                },
                                                                {
                                                                    label: "Emails",
                                                                    value: "email",
                                                                },
                                                            ]}
                                                            isRequired={
                                                                createOrderAction ? true : false
                                                            }
                                                        />
                                                        <div className="flex items-center gap-1 my-6">
                                                            <p className="text-gm-45 text-xs">
                                                                Turn{" "}
                                                                {agentSteps[currentStepIndex]
                                                                    ?.actions?.[0]?.approvalPossible
                                                                    ? "off"
                                                                    : "on"}{" "}
                                                                need for approval
                                                            </p>
                                                            <ToggleInput
                                                                checked={
                                                                    agentSteps[currentStepIndex]
                                                                        ?.actions?.[0]
                                                                        ?.approvalPossible as boolean
                                                                }
                                                                name={"approvalPossible"}
                                                                onChange={(e) => {
                                                                    const newAgentSteps = [
                                                                        ...agentSteps,
                                                                    ];
                                                                    newAgentSteps[
                                                                        currentStepIndex
                                                                    ].actions[0].approvalPossible =
                                                                        e.target.checked;
                                                                    setAgentSteps(newAgentSteps);
                                                                }}
                                                                className="w-slider before:!h-4 before:!w-4 h-5 w-[30px] before:left-[2px] rounded-[30px]"
                                                            />
                                                        </div>
                                                        {agentSteps[currentStepIndex]?.actions?.[0]
                                                            ?.approvalPossible && (
                                                            <SelectInput
                                                                value={
                                                                    agentSteps[currentStepIndex]
                                                                        ?.actions?.[0]
                                                                        ?.approvalIdString || ""
                                                                }
                                                                name="approvalIdString"
                                                                placeholder={"Select approver"}
                                                                handleChange={(name, value) => {
                                                                    handleActionChange(
                                                                        currentStepIndex,
                                                                        name,
                                                                        value
                                                                    );
                                                                }}
                                                                handleInputChange={debounce(
                                                                    (evt) => {
                                                                        setDebouncedSearchTeamMember(
                                                                            evt.target.value
                                                                        );
                                                                    },
                                                                    800
                                                                )}
                                                                isRequired={
                                                                    agentSteps[currentStepIndex]
                                                                        ?.actions?.[0]
                                                                        ?.approvalPossible
                                                                }
                                                                searchLoading={fetchingTeamMember}
                                                                dropdownOptions={teamMembers?.map(
                                                                    (member) => ({
                                                                        label: member?.fullName
                                                                            ? member?.fullName
                                                                            : member?.email,
                                                                        value: member?._id,
                                                                    })
                                                                )}
                                                                dropdownClassName="!pb-0 !max-h-[320px]"
                                                                rightDropdownContainerClassName="!sticky bottom-0"
                                                                customRightDropdownContainer={
                                                                    <div className="py-1 px-1  flex items-center  bg-white !h-[48px] sticky w-full bottom-0 border-t border-slate-200">
                                                                        <div
                                                                            className="flex items-center w-fit cursor-pointer gap-2"
                                                                            onClick={() => {
                                                                                setAddTeamMemberModal(
                                                                                    true
                                                                                );
                                                                            }}
                                                                        >
                                                                            <i className="ri-add-fill text-[#D39901] text-[10px] rounded-full py-0.5 px-1 bg-[#FFF5DA]"></i>

                                                                            <span className="text-[12px] font-rocGroteskMedium text-[#D39901] underline">
                                                                                Add a new team-mate
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            />
                                                        )}
                                                        {agentSteps[currentStepIndex]?.actions?.[0]
                                                            ?.externalSystem === "email" && (
                                                            <div className="">
                                                                <div className="space-y-4">
                                                                    <div className="flex items-center gap-2">
                                                                        <p className="bg-slate-200 flex-1 h-[1px] w-full"></p>
                                                                        <p className="text-slate-500 text-sm">
                                                                            Email template
                                                                        </p>
                                                                        <p className="bg-slate-200 flex-1 h-[1px] w-full"></p>
                                                                    </div>
                                                                    <div className="">
                                                                        <p className="text-b-55 text-sm">
                                                                            Send to:
                                                                        </p>
                                                                        <div className="space-y-2 mt-1">
                                                                            <TextInput
                                                                                name={
                                                                                    "additionalEmails"
                                                                                }
                                                                                type={"email"}
                                                                                value={
                                                                                    additionalEmails
                                                                                }
                                                                                placeholder={
                                                                                    "Click to add or edit email addresses"
                                                                                }
                                                                                onChange={(e) => {
                                                                                    handleMultipleEmails(
                                                                                        e
                                                                                    );
                                                                                }}
                                                                                setValueArray={
                                                                                    setValueArray
                                                                                }
                                                                                valueArray={
                                                                                    valueArray
                                                                                }
                                                                                onKeyDown={(
                                                                                    evt
                                                                                ) => {
                                                                                    if (
                                                                                        [
                                                                                            "Enter",
                                                                                            ",",
                                                                                            " ",
                                                                                        ].includes(
                                                                                            evt.key
                                                                                        )
                                                                                    ) {
                                                                                        evt.preventDefault();
                                                                                        if (
                                                                                            emailRegex.test(
                                                                                                additionalEmails
                                                                                            ) &&
                                                                                            !valueArray.includes(
                                                                                                additionalEmails
                                                                                            )
                                                                                        ) {
                                                                                            setValueArray(
                                                                                                [
                                                                                                    ...valueArray,
                                                                                                    additionalEmails,
                                                                                                ]
                                                                                            );
                                                                                            setAdditionalEmails(
                                                                                                ""
                                                                                            );
                                                                                        } else {
                                                                                            toast.custom(
                                                                                                (
                                                                                                    t
                                                                                                ) => (
                                                                                                    <CustomToast
                                                                                                        t={
                                                                                                            t
                                                                                                        }
                                                                                                        message={
                                                                                                            "Please enter a valid email address "
                                                                                                        }
                                                                                                        type={
                                                                                                            "error"
                                                                                                        }
                                                                                                    />
                                                                                                )
                                                                                            );
                                                                                        }
                                                                                    }
                                                                                }}
                                                                                autoCompleteOff={
                                                                                    true
                                                                                }
                                                                                inputClassName={
                                                                                    "!placeholder:text-slate-400 !placeholder:font-rocGroteskMedium"
                                                                                }
                                                                                inputContainerClassname="!min-h-[50px] !h-auto"
                                                                                required={
                                                                                    agentSteps[
                                                                                        currentStepIndex
                                                                                    ]?.actions?.[0]
                                                                                        ?.externalSystem ===
                                                                                    "email"
                                                                                        ? true
                                                                                        : false
                                                                                }
                                                                            />
                                                                            <p className="text-gm-45 text-[11px] font-rocGroteskMedium">
                                                                                Click “Enter” or
                                                                                comma (,) to add
                                                                                multiple
                                                                            </p>
                                                                        </div>
                                                                    </div>

                                                                    <TextareaInput
                                                                        name={"body"}
                                                                        value={
                                                                            agentSteps[
                                                                                currentStepIndex
                                                                            ]?.actions?.[0]
                                                                                ?.externalSystemPayload
                                                                                ?.body || ""
                                                                        }
                                                                        onChange={(e) => {
                                                                            handleActionChange(
                                                                                currentStepIndex,
                                                                                "body",
                                                                                e.target.value
                                                                            );
                                                                        }}
                                                                        rows={3}
                                                                        placeholder={"Enter body"}
                                                                        inputPlaceholder="Add custom message"
                                                                        required={
                                                                            agentSteps[
                                                                                currentStepIndex
                                                                            ]?.actions?.[0]
                                                                                ?.externalSystem ===
                                                                            "email"
                                                                                ? true
                                                                                : false
                                                                        }
                                                                    />

                                                                    <div className="mb-2">
                                                                        <p className="text-b-55 text-sm">
                                                                            File template
                                                                        </p>

                                                                        {agentSteps[
                                                                            currentStepIndex
                                                                        ]?.actions?.[0]
                                                                            ?.externalSystemPayload
                                                                            ?.attachments?.length >
                                                                            0 &&
                                                                            agentSteps[
                                                                                currentStepIndex
                                                                            ]?.actions?.[0]?.externalSystemPayload?.attachments?.map(
                                                                                (doc, idx) => (
                                                                                    <div className="flex space-x-1 w-full items-center">
                                                                                        <div className="flex w-full mb-2 items-center p-3 rounded-[6px] space-x-3 border border-[#F1F5F9]">
                                                                                            {displayFileIcon(
                                                                                                getFileTypeFromUrl(
                                                                                                    doc?.filename
                                                                                                ),
                                                                                                true,
                                                                                                "w-[25px] h-[25px]"
                                                                                            )}
                                                                                            <div>
                                                                                                <p className="text-sm font-rocGroteskMedium text-slate-700">
                                                                                                    {
                                                                                                        doc?.filename
                                                                                                    }
                                                                                                </p>
                                                                                            </div>
                                                                                        </div>
                                                                                        <i
                                                                                            className="ri-delete-bin-line text-xl text-r-50 cursor-pointer"
                                                                                            onClick={() =>
                                                                                                deleteAttachment(
                                                                                                    currentStepIndex,
                                                                                                    idx
                                                                                                )
                                                                                            }
                                                                                        ></i>
                                                                                    </div>
                                                                                )
                                                                            )}

                                                                        {uploadingDoc ? (
                                                                            <Loader />
                                                                        ) : (
                                                                            <div
                                                                                className="mt-2 flex items-center  w-full gap-4 cursor-pointer  border border-slate-200 rounded-md py-4 px-6 border-dashed"
                                                                                onClick={() =>
                                                                                    document
                                                                                        .getElementById(
                                                                                            "fileInput"
                                                                                        )
                                                                                        ?.click()
                                                                                }
                                                                            >
                                                                                <i className="ri-file-add-line text-2xl text-carribean-green"></i>
                                                                                <div className="font-rocGroteskMedium">
                                                                                    <p className="text-sm underline text-gm-50 ">
                                                                                        Click to
                                                                                        upload
                                                                                        document
                                                                                    </p>
                                                                                    <span className="text-[13px] text-[#6B778C]">
                                                                                        .JPEG .PDF
                                                                                        .CSV .DOCX |
                                                                                        File size
                                                                                        limit: 25MB
                                                                                    </span>
                                                                                </div>
                                                                                <input
                                                                                    type="file"
                                                                                    id="fileInput"
                                                                                    className={`absolute z-[-1]  opacity-0`}
                                                                                    // accept=".pdf,csv,docx,image/*"
                                                                                    multiple
                                                                                    onChange={(
                                                                                        evt
                                                                                    ) => {
                                                                                        if (
                                                                                            !isFileSizeLessThanOrEqualTo(
                                                                                                evt
                                                                                                    .target
                                                                                                    .files[0],
                                                                                                25
                                                                                            )
                                                                                        ) {
                                                                                            toast.custom(
                                                                                                (
                                                                                                    t
                                                                                                ) => (
                                                                                                    <CustomToast
                                                                                                        t={
                                                                                                            t
                                                                                                        }
                                                                                                        message={
                                                                                                            "File to large"
                                                                                                        }
                                                                                                        type={
                                                                                                            "error"
                                                                                                        }
                                                                                                    />
                                                                                                )
                                                                                            );
                                                                                            return;
                                                                                        } else {
                                                                                            handleUpload(
                                                                                                evt
                                                                                                    .target
                                                                                                    .files[0]
                                                                                                    .name,
                                                                                                evt
                                                                                                    .target
                                                                                                    .files[0],
                                                                                                currentStepIndex
                                                                                            );
                                                                                        }
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    <div className="flex items-center gap-2">
                                                                        <p className="bg-slate-200 flex-1 h-[1px] w-full"></p>
                                                                        <p className="text-slate-500 text-sm">
                                                                            Custom instructions
                                                                        </p>
                                                                        <p className="bg-slate-200 flex-1 h-[1px] w-full"></p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                        <TextareaInput
                                                            name={"customInstructions"}
                                                            value={
                                                                agentSteps[currentStepIndex]
                                                                    ?.actions?.[0]
                                                                    ?.customInstructions || ""
                                                            }
                                                            onChange={(e) => {
                                                                handleActionChange(
                                                                    currentStepIndex,
                                                                    "customInstructions",
                                                                    e.target.value
                                                                );
                                                            }}
                                                            rows={3}
                                                            placeholder={"Enter custom instruction"}
                                                            inputPlaceholder="Provide any specific instructions you'd like the AI Agent to follow. "
                                                            required={false}
                                                        />
                                                        <div className="mt-4">
                                                            <p className="text-sm text-slate-500 p-3 bg-slate-100 border border-slate-200 rounded">
                                                                Custom instructions let you tailor
                                                                how your AI Agent behaves in
                                                                specific steps of a workflow. Use
                                                                them to guide the Agent's tone,
                                                                priorities, or handling of unique
                                                                business rules. This helps ensure
                                                                your AI Agent aligns with your
                                                                brand's voice and operational
                                                                standards.
                                                            </p>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </AgentSideDrawer>
                    {/* Compose draft emails, order_email_draft */}

                    <AgentSideDrawer open={currentStep === "order_email_draft"} modalRef={modalRef}>
                        <div className=" flex  !bg-white flex-col  font-rocGroteskMedium  ">
                            <div className="relative">
                                {" "}
                                <div className="px-6 py-6">
                                    <div className="flex justify-between  items-center">
                                        <p className="text-sm font-rocGroteskMedium text-slate-800">
                                            AI Teammate's customization
                                        </p>
                                        <i
                                            className="ri-close-fill text-xl text-slate-500 cursor-pointer border border-slate-200 rounded py-0 px-1"
                                            onClick={() => {
                                                setCurrentStep("");
                                            }}
                                        ></i>
                                    </div>
                                    <p className="text-sm text-slate-500 ">
                                        Set how you want this AI team-mate to work
                                    </p>
                                </div>
                                <div className="mx-6 border border-slate-200 p-4 rounded-lg">
                                    <div className="space-y-3">
                                        <div className="flex justify-between">
                                            <div className="flex gap-0.5 items-center">
                                                <p className="text-sm text-slate-800">
                                                    Compose draft emails
                                                </p>
                                                <SynthTooltip
                                                    divId={agentSteps[currentStepIndex]?.key}
                                                    position={"top"}
                                                    icon={
                                                        <i className="ri-information-fill text-slate-300 text-sm"></i>
                                                    }
                                                    contentIcon={<></>}
                                                    title=""
                                                    content={
                                                        agentSteps[currentStepIndex]?.description
                                                    }
                                                    styling={{
                                                        width: "270px",
                                                        background: "#142837",
                                                        borderRadius: "6px",
                                                    }}
                                                    contentClass="text-xs"
                                                />
                                            </div>

                                            {agentSteps[currentStepIndex]?.showApproval && (
                                                <div className="flex items-center gap-1">
                                                    <p className="text-gm-45 text-xs">
                                                        Turn{" "}
                                                        {agentSteps[currentStepIndex]
                                                            ?.approvalPossible
                                                            ? "off"
                                                            : "on"}{" "}
                                                        need for approval
                                                    </p>
                                                    <ToggleInput
                                                        checked={
                                                            agentSteps[currentStepIndex]
                                                                ?.approvalPossible as boolean
                                                        }
                                                        name={"approvalPossible"}
                                                        onChange={(e) => {
                                                            handleAgentStepChange(
                                                                currentStepIndex,
                                                                "approvalPossible",
                                                                e.target.checked ? true : false
                                                            );
                                                        }}
                                                        className="w-slider before:!h-4 before:!w-4 h-5 w-[30px] before:left-[2px] rounded-[30px]"
                                                    />
                                                </div>
                                            )}
                                        </div>
                                        <div className="flex items-center gap-2">
                                            <p className="bg-slate-200 flex-1 h-[1px] w-full"></p>
                                            <p className="text-slate-500 text-sm">
                                                Select approver
                                            </p>
                                            <p className="bg-slate-200 flex-1 h-[1px] w-full"></p>
                                        </div>

                                        {agentSteps[currentStepIndex]?.approvalPossible && (
                                            <SelectInput
                                                value={
                                                    agentSteps[currentStepIndex]?.approverName ||
                                                    (agentSteps[currentStepIndex]
                                                        ?.approvalIdString as string) ||
                                                    ""
                                                }
                                                name="approvalIdString"
                                                nameFirst={true}
                                                placeholder={"Select approver"}
                                                handleChange={(name, value) => {
                                                    handleApproverChange(value);
                                                }}
                                                handleInputChange={debounce((evt) => {
                                                    setDebouncedSearchTeamMember(evt.target.value);
                                                }, 800)}
                                                isRequired={
                                                    agentSteps[currentStepIndex]?.approvalPossible
                                                }
                                                searchLoading={fetchingTeamMember}
                                                dropdownOptions={teamMembers?.map((member) => ({
                                                    label: member?.fullName
                                                        ? member?.fullName
                                                        : member?.email,
                                                    value: member?._id,
                                                }))}
                                                dropdownClassName="!pb-0 !max-h-[320px]"
                                                rightDropdownContainerClassName="!sticky bottom-0"
                                                customRightDropdownContainer={
                                                    <div className="py-1 px-1  flex items-center  bg-white !h-[48px] sticky w-full bottom-0 border-t border-slate-200">
                                                        <div
                                                            className="flex items-center w-fit cursor-pointer gap-2"
                                                            onClick={() => {
                                                                setAddTeamMemberModal(true);
                                                            }}
                                                        >
                                                            <i className="ri-add-fill text-[#D39901] text-[10px] rounded-full py-0.5 px-1 bg-[#FFF5DA]"></i>

                                                            <span className="text-[12px] font-rocGroteskMedium text-[#D39901] underline">
                                                                Add a new team-mate
                                                            </span>
                                                        </div>
                                                    </div>
                                                }
                                            />
                                        )}
                                        <TextareaInput
                                            name={"customInstructions"}
                                            value={
                                                agentSteps[currentStepIndex]?.customInstructions ||
                                                ""
                                            }
                                            onChange={(e) => {
                                                handleAgentStepChange(
                                                    currentStepIndex,
                                                    "customInstructions",
                                                    e.target.value
                                                );
                                            }}
                                            rows={3}
                                            placeholder={"Enter custom instructions"}
                                            inputPlaceholder="Provide any specific instructions you'd like the AI Agent to follow. "
                                            required={false}
                                        />
                                    </div>

                                    <div className="mt-4">
                                        <p className="text-sm text-slate-500 p-3 bg-slate-100 border border-slate-200 rounded">
                                            Custom instructions let you tailor how your AI Agent
                                            behaves in specific steps of a workflow. Use them to
                                            guide the Agent's tone, priorities, or handling of
                                            unique business rules. This helps ensure your AI Agent
                                            aligns with your brand's voice and operational
                                            standards.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </AgentSideDrawer>
                    {/* Respond to emails, order_email_send */}
                    <AgentSideDrawer open={currentStep === "order_email_send"} modalRef={modalRef}>
                        <div className=" flex  !bg-white flex-col  font-rocGroteskMedium  ">
                            <div className="relative ">
                                <div className="px-6 py-6">
                                    <div className="flex justify-between  items-center">
                                        <p className="text-sm font-rocGroteskMedium text-slate-800">
                                            AI Teammate's customization
                                        </p>
                                        <i
                                            className="ri-close-fill text-xl text-slate-500 cursor-pointer border border-slate-200 rounded py-0 px-1"
                                            onClick={() => {
                                                setCurrentStep("");
                                            }}
                                        ></i>
                                    </div>
                                    <p className="text-sm text-slate-500 ">
                                        Set how you want this AI team-mate to work
                                    </p>
                                </div>
                                <div className="mx-6 border border-slate-200 p-4 rounded-lg">
                                    <div className="space-y-3">
                                        <div className="flex justify-between">
                                            <div className="flex gap-0.5 items-center">
                                                <p className="text-sm text-slate-800">
                                                    Respond to emails
                                                </p>
                                                <SynthTooltip
                                                    divId={agentSteps[currentStepIndex]?.key}
                                                    position={"top"}
                                                    icon={
                                                        <i className="ri-information-fill text-slate-300 text-sm"></i>
                                                    }
                                                    contentIcon={<></>}
                                                    title=""
                                                    content={
                                                        agentSteps[currentStepIndex]?.description
                                                    }
                                                    styling={{
                                                        width: "270px",
                                                        background: "#142837",
                                                        borderRadius: "6px",
                                                    }}
                                                    contentClass="text-xs"
                                                />
                                            </div>

                                            {agentSteps[currentStepIndex]?.showApproval && (
                                                <div className="flex items-center gap-1">
                                                    <p className="text-gm-45 text-xs">
                                                        Turn{" "}
                                                        {agentSteps[currentStepIndex]
                                                            ?.approvalPossible
                                                            ? "off"
                                                            : "on"}{" "}
                                                        need for approval
                                                    </p>
                                                    <ToggleInput
                                                        checked={
                                                            agentSteps[currentStepIndex]
                                                                ?.approvalPossible as boolean
                                                        }
                                                        name={"approvalPossible"}
                                                        onChange={(e) => {
                                                            handleAgentStepChange(
                                                                currentStepIndex,
                                                                "approvalPossible",
                                                                e.target.checked ? true : false
                                                            );
                                                        }}
                                                        className="w-slider before:!h-4 before:!w-4 h-5 w-[30px] before:left-[2px] rounded-[30px]"
                                                    />
                                                </div>
                                            )}
                                        </div>
                                        <div className="flex items-center gap-2">
                                            <p className="bg-slate-200 flex-1 h-[1px] w-full"></p>
                                            <p className="text-slate-500 text-sm">
                                                Select approver
                                            </p>
                                            <p className="bg-slate-200 flex-1 h-[1px] w-full"></p>
                                        </div>

                                        {agentSteps[currentStepIndex]?.approvalPossible && (
                                            <SelectInput
                                                value={
                                                    agentSteps[currentStepIndex]?.approverName ||
                                                    (agentSteps[currentStepIndex]
                                                        ?.approvalIdString as string) ||
                                                    ""
                                                }
                                                name="approvalIdString"
                                                placeholder={"Select approver"}
                                                handleChange={(name, value) => {
                                                    handleApproverChange(value);
                                                }}
                                                handleInputChange={debounce((evt) => {
                                                    setDebouncedSearchTeamMember(evt.target.value);
                                                }, 800)}
                                                isRequired={true}
                                                searchLoading={fetchingTeamMember}
                                                dropdownOptions={teamMembers?.map((member) => ({
                                                    label: member?.fullName
                                                        ? member?.fullName
                                                        : member?.email,
                                                    value: member?._id,
                                                }))}
                                                dropdownClassName="!pb-0 !max-h-[320px]"
                                                rightDropdownContainerClassName="!sticky bottom-0"
                                                customRightDropdownContainer={
                                                    <div className="py-1 px-1  flex items-center  bg-white !h-[48px] sticky w-full bottom-0 border-t border-slate-200">
                                                        <div
                                                            className="flex items-center w-fit cursor-pointer gap-2"
                                                            onClick={() => {
                                                                setAddTeamMemberModal(true);
                                                            }}
                                                        >
                                                            <i className="ri-add-fill text-[#D39901] text-[10px] rounded-full py-0.5 px-1 bg-[#FFF5DA]"></i>

                                                            <span className="text-[12px] font-rocGroteskMedium text-[#D39901] underline">
                                                                Add a new team-mate
                                                            </span>
                                                        </div>
                                                    </div>
                                                }
                                            />
                                        )}

                                        <TextareaInput
                                            name={"customInstructions"}
                                            value={
                                                agentSteps[currentStepIndex]?.customInstructions ||
                                                ""
                                            }
                                            onChange={(e) => {
                                                handleAgentStepChange(
                                                    currentStepIndex,
                                                    "customInstructions",
                                                    e.target.value
                                                );
                                            }}
                                            rows={3}
                                            placeholder={"Enter custom instructions"}
                                            inputPlaceholder="Provide any specific instructions you'd like the AI Agent to follow. "
                                            required={false}
                                        />
                                    </div>

                                    <div className="mt-4">
                                        <p className="text-sm text-slate-500 p-3 bg-slate-100 border border-slate-200 rounded">
                                            Custom instructions let you tailor how your AI Agent
                                            behaves in specific steps of a workflow. Use them to
                                            guide the Agent's tone, priorities, or handling of
                                            unique business rules. This helps ensure your AI Agent
                                            aligns with your brand's voice and operational
                                            standards.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </AgentSideDrawer>
                </>
            )}

            {/* //email modal */}
            <ModalContainer
                open={emailClientModal}
                showCloseIcon={false}
                tailwindClassName="w-[38%] max-lg:w-1/2 max-sm:w-[95%]"
                closeModal={() => {
                    setEmailClientModal(false);
                }}
            >
                <div className="bg-white rounded-lg shadow-cardShadow relative">
                    <div className="px-10 pt-3 pb-5">
                        <div className="flex flex-col items-center text-center mb-1">
                            <div className="flex w-full justify-end mr-[-12px]">
                                <i
                                    onClick={() => setEmailClientModal(false)}
                                    className="ri-close-fill text-2xl"
                                ></i>
                            </div>
                            <div className="mb-4 relative w-12 h-12 rounded-full flex items-center justify-center bg-[#FF3D1D17]">
                                <i className="ri-information-fill text-r-50 text-2xl"></i>
                            </div>
                            <p className="text-[22px] mb-1.5 text-center  font-rocGroteskMedium text-g-75">
                                Connect your account
                            </p>
                            <p className="text-base text-center font-rocGroteskMedium text-slate-500">
                                Please select an account to continue
                            </p>
                        </div>

                        {emailClients?.length > 0 ? (
                            <div>
                                {emailClients?.map((client, idx) => {
                                    return (
                                        <div
                                            key={client?._id}
                                            className={`flex items-center justify-between py-2.5 ${
                                                idx < emailClients?.length - 1 && "border-b"
                                            } border-slate-200 w-full`}
                                        >
                                            <div className="flex items-center space-x-3">
                                                {displayProductChannelIcon(
                                                    client?.channel,
                                                    "!w-[22px] !h-[22px]"
                                                )}
                                                <div>
                                                    <span className="block text-base text-slate-500 font-rocGroteskMedium capitalize">
                                                        {client?.channel}
                                                    </span>
                                                    <span className="block text-xs text-slate-500 font-rocGroteskMedium capitalize">
                                                        {client?.creds?.account?.email}
                                                    </span>
                                                </div>
                                            </div>

                                            {client?.socialId === emailClientSocialId ? (
                                                <div className="flex items-center space-x-2.5">
                                                    <span className="text-sm font-rocGroteskMedium">
                                                        Selected
                                                    </span>
                                                    <i className="ri-checkbox-circle-fill text-carribean-green"></i>
                                                </div>
                                            ) : (
                                                <Button
                                                    btnText="Select"
                                                    btnPermission={[
                                                        AccountPermissions.all_access,
                                                        AccountPermissions.manage_integrations,
                                                        AccountPermissions.create_ai_teammate,
                                                    ]}
                                                    btnClassname="!px-4 !py-2 !bg-tradeally-neutral-20 !w-fit !h-[32px]"
                                                    disabled={false}
                                                    onClick={() => {
                                                        setEmailClientSocialId(client?._id);
                                                        setEmailClientModal(false);
                                                    }}
                                                />
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <div>
                                <EmptyStateComp
                                    title="No email accounts found"
                                    description="There are currently no email integrations found, please integrate your email account"
                                    icon={
                                        <i className="ri-mail-forbid-line text-slate-500 text-[40px]"></i>
                                    }
                                    hasButton
                                    btnText="Integrate email account"
                                    contentContainerClass="!w-full !p-6"
                                    btnAction={() => {
                                        if (agentId) {
                                            saveToStorage(
                                                "connectedRedirect",
                                                `/dashboard/workforce/ai-teammate/non-active/${agentId}`
                                            );
                                        } else {
                                            saveToStorage(
                                                "connectedRedirect",
                                                `/dashboard//workforce/ai-teammate/${aiTeammateId}/${agentId}`
                                            );
                                        }

                                        saveToStorage(
                                            "createAiAgentForm",
                                            {
                                                agentIsActive,
                                                avatar,
                                                ...(agentDetails?.type === "orderProcessing" && {
                                                    valueArray,
                                                }),
                                                agentDetails,
                                                emailClientSocialId,
                                                aiAgentName,
                                                sourceActionTrigger,
                                                selectedAction,
                                                agentSteps,
                                                type: agentDetails?.type,
                                            },
                                            true
                                        );

                                        navigate("/dashboard/integrations", {
                                            state: { internalNavigation: true },
                                        });
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </ModalContainer>

            {/* successModal */}
            <ModalContainer
                open={successModal}
                modalClassName={"py-10 px-10"}
                tailwindClassName="w-[552px]"
                showCloseIcon={false}
                closeModal={() => {
                    setSuccessModal(false);

                    // setActiveTab(1);
                    navigate(
                        `/dashboard/workforce/ai-teammate/${aiTeammateId}/${agentDetails?._id}?currTab=1`
                    );
                }}
            >
                <div className="bg-white rounded-[8px] relative">
                    <i
                        className="ri-close-fill cursor-pointer text-gm-50 text-xl absolute  top-4 right-4"
                        onClick={() => {
                            // setActiveTab(1);
                            setSuccessModal(true);
                            navigate(
                                `/dashboard/workforce/ai-teammate/${aiTeammateId}/${agentDetails?._id}?currTab=1`
                            );
                        }}
                    ></i>
                    <div className="mt-4 ">
                        <div className="text-center flex justify-center flex-col items-center px-8 pt-10 mb-8">
                            <div className="mb-4 w-12 h-12 bottom-0 right-[-13px] rounded-full bg-[#00DB8F] flex items-center justify-center">
                                <i className="ri-checkbox-circle-fill text-[24px] text-white"></i>
                            </div>
                            <div className="px-6 font-rocGroteskMedium">
                                <span className="block mb-2 text-center text-[18px] text-[#142837]">
                                    AI Agent Created Successfully
                                </span>
                                <p className="mt-1 text-base text-slate-500 text-center ">
                                    Your AI Agent is now live and ready for work. It will
                                    automatically detect and handle tasks based on your workflow
                                    setup.{" "}
                                </p>
                            </div>
                        </div>
                        <div className="border-t border-t-slate-200 py-4 px-6 flex items-center space-x-4">
                            <Button
                                btnText={"Set up another agent"}
                                btnClassname="!py-3 cursor-pointer !text-[14px] !bg-n-20 !text-g-75 !border border-n-20 !font-rocGroteskMedium !px-4"
                                onClick={() => {
                                    navigate(`/dashboard/workforce`, {
                                        state: { internalNavigation: true },
                                    });
                                }}
                            />
                            <Button
                                btnText={"View Agent Activity"}
                                btnClassname="!py-3 cursor-pointer !text-[14px] !text-g-75 !border border-n-20 !font-rocGroteskMedium !px-4"
                                onClick={() => {
                                    // setActiveTab(1);
                                    navigate(
                                        `/dashboard/workforce/ai-teammate/${aiTeammateId}/${agentDetails?._id}?currTab=1`
                                    );
                                }}
                            />
                        </div>
                    </div>
                </div>
            </ModalContainer>
            <AddTeamMemberModal
                addNewMember={addTeamMemberModal}
                setAddNewMember={setAddTeamMemberModal}
            />
        </div>
    );
};

export default Setup;
